import {v4 as uuidv4} from "uuid";
import axios from "axios";
import _ from "lodash";
import MockAdapter from "axios-mock-adapter";
import {
  DEMO_USER_SIGN_IN,
  USER_PRE_SIGN_IN,
  USER_SIGN_UP,
  USER_FORGOTPASSWORD_URL,
  USER_CONFIRM_FORGOTPASSWORD_URL,
  USER_RESEND_CONFIRMATION,
  AMI_LIST_URL,
  PATCHES_PATCHLIST_URL,
  PATCH_POLICIES_LIST_URL,
  EC2_INSTANCE_BASE_URL,
  WORKSPACES_BASE_URL,
  RDP_CONFIG_URL,
  CUSTOMER_ACCOUNT,
  ACCOUNT_REMOVE_URL,
  GLOBAL_REGION_LIST_URL,
  GLOBAL_USER_DATA,
  SCHEDULED_TASKS_LIST_URL,
  INTEGRATIONS_BASE_URL,
  SUMMARY,
  SPECIFICATION,
  SSO_CONFIGURATION,
  SSO_CONFIGURATIONS,
  SSO_ENABLED_URL,
  CUSTOMER_DOMAINS,
  CUSTOMER_DOMAIN,
  VERIFY,
  SSO_ACTIVE_SETTINGS,
  SSO_APPLICATION_ROLES,
  SERVER_GROUP_BASE_URL,
  SERVER_GROUPS_BASE_URL,
  ORGANIZATION_SUMMARY_URL,
  ORGANIZATIONS_BASE_URL,
  ORGANIZATION_BASE_URL,
  APP_ALERTS_URL,
  RESOURCES_LIST_URL,
  APPLICATIONS_BASE_URL,
  BLUEPRINTS_LIST_URL,
  CUSTOM_TASKS_BASE_URL,
  JOBS_LIST_URL,
  REPORTS_BASE_URL,
  SCHEDULE_BASE_URL,
  OS_PATCH_REPORT_URL,
  REPORT_EXPORTS_URL,
  REPORTS_BASE_V2_URL,
  REPORTS_URL,
  JOB_SCHEDULE_BASE_URL,
  ROLES_BASE_URL,
  ROLE_BASE_URL,
  USERS_BASE_URL,
  NOTIFICATIONS_BASE_URL,
  BLUEPRINT_ID_URL,
  BLUEPRINTS_BASE_URL,
  BLUEPRINTS_TEMPLATE_URL,
  BLUEPRINTS_STACKS_URL,
  BLUEPRINTS_HISTORY_URL,
  BLUEPRINT_CONFIG_URL,
  BLUEPRINTS_LAUNCH_URL,
  USER_BASE_URL,
  DATA_REFRESH_BASE_URL,
  PATCH_POLICY_SAVE_URL,
  CUSTOMER_ACCOUNT_STATUS,
  ROUTINE_TASKS_URL,
  TASKS_BASE_URL,
  EC2_INSTANCE_SESSION_START_URL,
  EC2_SNAPSHOT_INSTANCE_URL,
  EC2_INSTANCE_SESSION_TERMINATE_URL,
  EC2_INSTANCE_SESSIONS_LIST_URL,
  CUSTOMER_ACCOUNT_CONFIGURE_REGIONS_URL,
  BLUEPRINTS_CATEGORY,
  BLUEPRINTS_VALIDATE,
  DESIRED_STATE_POLICIES_LIST_URL,
  DESIRED_STATE_POLICY_SAVE_URL,
  RESOURCE_TAGS_URL,
  IAM_ROLE_POLICIES,
  MANIFEST_PARAMETERS_URL,
  UPLOAD_MANIFEST,
  ORG_APPLICATION_BASE_URL,
  MONITORING_URL,
  CHANGE_CONFIGURATION,
  MONITORING_STATISTICS_URL,
  RESOURCE_EXIST_URL,
  ORG_RESOURCE_TAGS_URL,
  CUSTOMER_ACCOUNT_STATE,
  CUSTOMER_REGION_STATE,
  BLUEPRINT_CUSTOM_POLICY_DETAILS,
  USER_LOGOUT,
  GET_ACTIVATION_CODE,
  GET_HYBRID_ACTIVATION_ROLE_DETAILS,
  ORG_RESOURCE_BASE_URL,
  METRICS,
  PACKAGES,
  PACKAGE_CLOUD_WATCH,
  LIST,
  BLUEPRINT_COST_URL,
  LAUNCH_CONFIGURATIONS_URL,
  LAUNCH_CONFIGURATION_URL,
  APP_RULES,
  APP_EXECUTION_HISTORY,
  EVENT_METADATA,
  INSIGHTS,
  SUPPRESS,
  BOTS_BASE_URL,
  REMEDIATE,
  MANIFEST,
  CONFIGURE,
  RESOURCES_EXIST_URL,
  PREREQUISITES_CHECK,
  JOBS_BASE_URL,
  STORAGE_OBJECTS,
  FOLDER,
  FILE,
  PRODUCT_CATALOG,
  SUBSCRIPTION,
  PLANS,
  ENTERPRISE_REQUEST,
  ORG_BASE_URL,
  RESOURCE_INSIGHT_SUMMARY_URL,
  RESOURCE_INSIGHTS_URL,
  DEPARTMENT_BASE_URL,
  CUSTOMER_PREFERENCE,
  ACCOUNTS_TEMPLATES,
  CFN,
  TASK_BASE_URL,
  CONFIG,
  OFFBOARDING,
  ORG_INVENTORY_SUMMARY,
  ORG_GOVERNANCE_SUMMARY,
  BOT_SUMMARY,
  OPS_SUMMARY,
  ORG_COST_OPTIMIZATION_SUMMARY,
  SUPPORT_TICKET_URL,
  STORAGE,
  EC2_FILE,
  UPLOAD,
  RE_ORDER,
  MFA_CONFIG_URL,
  RESET_MFA_CONFIG,
  INITIATE_MFA_SETUP_URL,
  REGISTER_MFA_DEVICE_URL,
  VERIFY_MFA_URL,
  RESOURCE_TYPES,
  EC2_INSTANCE_LIST_URL,
  TYPES,
  VOLUMES_BASE_URL,
  PATCHES,
  REQUEST,
  REQUESTS,
  USERS_LIST_URL_V2,
  BOT_INDUSTRY_SUMMARY,
  DEPARTMENTS_BASE_URL,
  APPLICATION_BASE_URL,
  ENVIRONMENTS_BASE_URL,
  SUMMARY_BASE_URL,
  ORG_DEPARTMENT_BASE_URL,
  CUSTOMER_ACCOUNT_ORGANIZATION,
  TASK_SCHEDULE_BASE_URL,
  TASK_OUTPUT_LOGS,
  TERRAFORM_INFRA_SETUP_URL,
  TERRAFORM_INFRA_CONFIG_URL,
  RESOURCES_LIST_PAGINATED_URL,
  LIST_BLUEPRINT_SHARES_URL,
  SHARE_BLUEPRINT_CATALOG_URL,
  UNSHARE_BLUEPRINT_CATALOG_URL,
  AWS_ACCOUNT_BASE_URL,
  CONTROL_TOWER_URL,
  CONTROL_TOWER_ENABLED_URL,
  AWS_ACCOUNT_URL,
} from "../config/service";
import {
  getResources,
  allServerGroups,
  allServerGroupInstances,
  getAllAccounts,
  allInstances,
  allImages,
  allVolumes,
  allSubnets,
  allSnapshots,
  allPatches,
  allPatchPolicies,
  patchStates,
  addAccountData,
  addAccountRegions,
  accountResponseData,
  accountDetails,
  setDASStatus,
  regions,
  userdata,
  allSchedules,
  allIntegrations,
  getIntegrationSpec,
  allIntegrationsItems,
  getSSOActiveSettings,
  getSSORoles,
  initiateSSO,
  addDomain,
  editConfig,
  verifyDomain,
  deleteDomian,
  organizationSummary,
  createOrganization,
  // createDepartment,
  createApplication,
  createEnvironment,
  allBlueprints,
  createBlueprint,
  allBlueprintsCategories,
  createBlueprintCategory,
  allCustomTasks,
  getDesiredTaskDetails,
  preProcessImportedTasks,
  getCustomTaskManifest,
  allJobs,
  addJob,
  createJob,
  addInstanceJob,
  instanceData,
  allReports,
  reportDetails,
  getReportExports,
  usageTrendDetails,
  allCoudWatchEventRules,
  ecsClusterTemplate,
  ecsClusterManifest,
  appendedRoleText,
  allVpcs,
  vpcResources,
  allCfns,
  allIAMRoles,
  allKeyPairs,
  allLambdas,
  allIAMPolicies,
  allS3Buckets,
  getScanJobs,
  getStacksData,
  getAllJobTasks,
  blueprintId,
  appParameters,
  appSummary,
  users,
  createUser,
  roles,
  getNotificationList,
  createNotification,
  allApplications,
  getAppAlerts,
  ecsClusterResources,
  resourceSummary,
  createServerGroup,
  savePolicyData,
  accountStatusData,
  getBundledActions,
  createNewSchedule,
  allSecurityGroups,
  startSessionData,
  terminateSessionData,
  remoteSessionsList,
  allDesiredStatePolicies,
  desiredStatePolicyData,
  saveDesiredPolicyData,
  getAllTags,
  getResourcesforTags,
  getIamRoleDetails,
  getParameterGroups,
  cfnResources,
  getActivationCode,
  getActivationRoleDetails,
  monitoringMetric,
  checkCloudWatchUserExistData,
  detectCloudWatchAgentData,
  getMonitoringMetricData,
  getLaunchConfigurations,
  createLaunchConfiguration,
  getRules,
  getEventsMetadata,
  getEventConditionsData,
  createRule,
  getAllBotInsights,
  getAllRemediations,
  bringYourOwnAppTemplate,
  bringYourOwnAppManifest,
  getStacksDataByoa,
  getBundledActionsByoa,
  getBringYourOwnAppParameterGroups,
  getAllBots,
  getBotManifest,
  getBotDetails,
  configureBot,
  getPreRequisites,
  allFileObjects,
  subscriptionProductCatalog,
  subscribedPlans,
  getResourceInsights,
  getResourceInsightSummary,
  getResourceInsightTypes,
  getAppTasks,
  reorderTasks,
  updateTasks,
  getBotConfig,
  offBoardBot,
  inventorySummaryByAccount,
  inventorySummaryByRegion,
  inventorySummaryByResource,
  azureGovernanceSummary,
  governanceSummary,
  getBotSummary,
  getBotOpsSummary,
  getCostOptimizationData,
  createProjectRequest,
  getProjectRequestsPending,
  getProjectRequestsInactive,
  getDepartmentsList,
  createProject,
  getPortalUsers,
  getBotIndustryStandards,
  allProjectFileObjects,
} from "./factories";
import {
  jobId,
  LOCALSTORAGE_KEYS_WITH_ACCOUNTS,
  cfnPath,
  COMPLIANCE_INSIGHTS,
} from "./factories/constants";
import { changeState } from "./helpers/instance-helper";
import {
  getStorage,
  setStorage,
  removeItem,
  clearStorage,
} from "./helpers/storage";
import config from "../config";
import { faker } from '@faker-js/faker';
import { domainVerificationTxtCode } from "./factories/sso";
import { getBotType } from "../modules/day2-bots/utils";
import {
  BOT_TYPE_COMPLIANCE,
  WITHDRAWN_STATUS,
  REJECTED_STATUS,
  PENDING,
  APPROVED_STATUS,
  CUSTOMER_ROLE_FULL_ACCESS_ID,
  EMAIL,
  ALL_RESOURCES_SUMMARY_FILTERS,
  CLOUDPROVIDERS,
  FEATURE_PLANS,
} from "../utils/app-constants.json";
import { isArrayWithLength } from "../utils/array-methods";
import { COMPLIANCE_BOT_ID } from "../../src/utils/app-constants.json";
import resourceTypeCodes from "../utils/resourceTypeCodes.json";
import { userDetails } from "./factories/user-data";
import { allWorkspaces } from "./factories/workspace";
import {
  ACTIVE_PROJECTS,
  PROJECT_REQUESTS_INACTIVE,
  PROJECT_REQUESTS_PENDING,
  STATE,
  STATE_CHANGE_MESSAGE,
  MESSAGE,
  PORTAL_USERS,
  DEMO_PROJECT_USERS,
} from "./helpers/project-constants.json";
import { setUpWafrServices } from "./services/wafr-services";
import {
  WAFR_ASSESSMENT_REPORT_NAME,
  WAFR_FINDING_REPORT_NAME,
} from "./services/wafr-services-constants";
import { setUpMAPProjectsServices } from "./services/map-project-services";

import {
  customerPreferencesAdvance,
  customerPreferencesBasic,
  setupMTServices,
} from "./multi-tenancy/multi-tenancy";
import {
  ManagementAccountId,
  orgHierarchyMock,
} from "./mockData/org-hierarchy-data";
import { setUpFBPServices } from "./foundationalBestPractices/foundationalBestPractices";
import { getSnsTopics } from "./factories/snsTopics";

import {
  TERRAFORM_DRAFT_BP_ID,
  CREATE_TERRAFORM_BP_ID,
  TERRAFORM_COMPLETED_BP_ID,
} from "./factories/blueprints";

import TF_FILE_CONTEN_S3 from "./mockData/terraform-file-content.json";
import TF_FILE_CONTEN_EC2 from "./mockData/terraform-file-content-ec2.json";

import {
  terraformManifestCompleted,
  terraformManifestDraft,
  terraformCreateManifest,
  terraformAppParameters,
} from "./factories/ecs-cluster-template";
import azureResourceRegions from "./mockData/azure-resource-list.json";
import { getTaskOutputLogs } from "./factories/scanSchedule";
import { getCompletedTerraformExecutionHistory } from "./factories/bring-your-own-app-template";

import BLUEPRINT_ROLE_PERMISSIONS from "./mockData/role-permission.json";
import { TERRAFORM_ENV_ID } from "./scenarios/edu-scenarios";
import { s3TerraformArray } from "./factories/s3Buckets";
import {
  RdsTerraformArray,
  SecurityGroupTerraformArray,
  VolumeTerraformArray,
  routeTableTerraformArray,
} from "./factories/terraform";
import { listBlueprintShares } from "./mockData/blueprints";
import { shareBlueprint, unshareBlueprint } from "./factories/blueprints";
import {
  moveAccountToOU,
  updateOrgHierarchyData,
} from "./helpers/updateOrgHierarchyData";
import { costDashboardServices } from "./services/costDashboardService";

export default function startServer() {
  if (!config.demoApp) {
    return;
  }
  const mock = new MockAdapter(axios, {
    delayResponse: 1000,
    onNoMatch: "throwException",
  });

  setUpWafrServices(mock);

  setUpMAPProjectsServices(mock);

  costDashboardServices(mock);

  mock.onGet(/\/resource\/regions\?CloudProvider=Azure$/g).reply((config) => {
    return [200, azureResourceRegions];
  });

  mock.onGet(/\/resource\/regions\?CloudProvider=Azure$/g).reply((config) => {
    return [200, azureResourceRegions];
  });

  const taskOutputLogsUrl = new RegExp(
    `${TASK_SCHEDULE_BASE_URL}[0-9a-zA-Z-]+/${TASK_OUTPUT_LOGS}`
  );

  mock.onGet(taskOutputLogsUrl).reply(async (config) => {
    const url = config.url.split("/");
    const taskId = url.at(-2);
    const data = getTaskOutputLogs(taskId);
    return [200, data];
  });

  const logoutUrl = new RegExp(`${USER_LOGOUT}`);
  mock.onPost(logoutUrl).reply(async () => {
    await clearStorage();
    return [200, {}];
  });

  mock.onPost(USER_PRE_SIGN_IN).reply(() => {
    return [200, { status: "LOCAL_AUTH" }];
  });

  mock.onPost(DEMO_USER_SIGN_IN).passThrough();

  mock.onPost(USER_SIGN_UP).reply(() => {
    return [200, { Code: 200, Data: null, Error: null, Status: "Success" }];
  });

  mock.onPost(USER_FORGOTPASSWORD_URL).reply(() => {
    return [200, { Code: 200, Data: null, Error: null, Status: "Success" }];
  });

  mock.onPost(USER_CONFIRM_FORGOTPASSWORD_URL).reply(() => {
    return [200, { Code: 200, Data: null, Error: null, Status: "Success" }];
  });

  mock.onPost(USER_RESEND_CONFIRMATION).reply(() => {
    return [200, { Code: 200, Data: null, Error: null, Status: "Success" }];
  });

  //Region List

  mock.onGet(GLOBAL_REGION_LIST_URL).reply(() => {
    return [200, regions];
  });

  //Configure Regions

  mock.onPost(CUSTOMER_ACCOUNT_CONFIGURE_REGIONS_URL).reply(async (config) => {
    const data = JSON.parse(config.data);
    await addAccountRegions(data);
    return [200, { Code: 200, Data: null, Error: null, Status: "Success" }];
  });

  // Tenant List

  mock.onGet(ORGANIZATIONS_BASE_URL).reply(async () => {
    let organizations = await getStorage("ORGANIZATIONS");
    if (!organizations) {
      let orgs = await createOrganization();
      organizations = orgs;
    }
    await setStorage("ORGANIZATIONS", organizations);
    return [200, organizations];
  });

  // Create Environment

  const environmentURL = new RegExp(
    `${ORGANIZATION_BASE_URL}.+/department/.+/application/.+/environment/`
  );

  mock.onPost(environmentURL).reply(async (config) => {
    const url = config.url.split("/");
    const appId = url[url.length - 3];
    const deptId = url[url.length - 5];
    const orgId = url[url.length - 7];
    const data = JSON.parse(config.data);
    const orgs = await getStorage("ORGANIZATIONS");
    let org = orgs.find((o) => o.ID === orgId);
    let dept = org.Departments.find((d) => d.ID === deptId);
    let app = dept.Applications.find((a) => a.ID === appId);
    const environment = createEnvironment(data, orgId, deptId, appId);
    app["Environments"] = [environment];
    await setStorage("ORGANIZATIONS", orgs);
    return [200, environment];
  });

  // Create Application

  const applicationURL = new RegExp(
    `${ORGANIZATION_BASE_URL}.+/department/.+/application`
  );

  mock.onPost(applicationURL).reply(async (config) => {
    const url = config.url.split("/");
    const orgId = url[url.length - 5];
    const deptId = url[url.length - 3];
    const data = JSON.parse(config.data);
    const orgs = await getStorage("ORGANIZATIONS");
    let org = orgs.find((o) => o.ID === orgId);
    let dept = org.Departments.find((d) => d.ID === deptId);
    const application = await createApplication(data, orgId, deptId);
    dept && dept.Applications.unshift(application);
    let deptIndex = org.Departments.findIndex((d) => d.ID === deptId);
    org.Departments[deptIndex] = dept;
    let appList = await getStorage("APPLICATIONS");
    if (!appList) {
      appList = allApplications();
    }
    appList && appList.unshift(application);
    await setStorage("APP_MONITORING", data.Monitoring);
    await setStorage("APPLICATIONS", appList);
    await setStorage("ORGANIZATIONS", [org]);
    return [200, application];
  });

  // Create Department

  // const createDept = async (config) => {
  //   const url = config.url.split("/");
  //   const orgId = url[url.length - 3];
  //   const data = JSON.parse(config.data);
  //   const department = await createDepartment(data, orgId);
  //   const orgs = await getStorage("ORGANIZATIONS");
  //   let departments = orgs[0].Departments;
  //   departments.push(department);
  //   orgs[0].Departments = departments;
  //   await setStorage("ORGANIZATIONS", orgs);
  //   await setStorage("DEPARTMENTS", departments);
  //   return true;
  // };

  const departmentURL = new RegExp(`${ORGANIZATION_BASE_URL}.+/department/`);
  mock.onPost(departmentURL).reply(async (config) => {
    const url = config.url.split("/");
    const orgId = url[url.length - 3];
    const data = JSON.parse(config.data);
    let project = await createProject(data, orgId);

    let blueprints = await getStorage("BLUEPRINTS");
    if (project.Services && isArrayWithLength(project.Services.Blueprints)) {
      project.Services.Blueprints.forEach((blueprintId) => {
        let foundBlueprintIndex = blueprints.findIndex(
          (blueprint) => blueprint.BlueprintId === blueprintId
        );
        if (foundBlueprintIndex >= 0) {
          let foundBlueprint = blueprints[foundBlueprintIndex];

          if (isArrayWithLength(foundBlueprint.Depts)) {
            foundBlueprint.Depts.push(project.ID);
          } else {
            foundBlueprint.Depts = [project.ID];
          }
          blueprints[foundBlueprintIndex] = foundBlueprint;
        }
      });
    }
    await setStorage("BLUEPRINTS", blueprints);

    let organizations = await getStorage("ORGANIZATIONS");

    let departments = await getStorage(ACTIVE_PROJECTS);
    if (!departments || Object.keys(departments).length === 0) {
      departments = getDepartmentsList();
    }

    if (
      isArrayWithLength(organizations) &&
      isArrayWithLength(organizations[0].Departments)
    ) {
      organizations[0].Departments.push(project);
      await setStorage("ORGANIZATIONS", organizations);
    }

    departments.push(project);
    await setStorage(ACTIVE_PROJECTS, departments);
    return [200, { ID: project.ID }];
  });

  // const departmentURL = new RegExp(`${ORGANIZATION_BASE_URL}.+/department/`);
  // mock.onPost(departmentURL).reply(async (config) => {
  //   if (config.url.endsWith("department/")) {
  //     await createDept(config);
  //     return [200, {}];
  //   }
  // });

  // Blueprint List

  const blueprintListURL = new RegExp(`${BLUEPRINTS_LIST_URL}`);

  mock.onGet(blueprintListURL).reply(async (config) => {
    const filters = JSON.parse(decodeURI(config.url).split("Filters=")[1]);
    let blueprintMasterList = await getStorage("BLUEPRINTS");
    let blueprints = [];
    if (!blueprintMasterList) {
      blueprintMasterList = allBlueprints();
      await setStorage("BLUEPRINTS", blueprintMasterList);
    }
    if (filters.Depts) {
      blueprints = blueprintMasterList.filter(
        (blueprint) => _.intersection(filters.Depts, blueprint.Depts).length > 0
      );
    } else {
      blueprints = blueprintMasterList;
    }
    return [200, blueprints];
  });

  // Blueprint Categories

  const blueprintCategoryURL = new RegExp(`${BLUEPRINTS_CATEGORY}`);
  mock.onGet(blueprintCategoryURL).reply(async (config) => {
    let blueprintCategories = await getStorage("BLUEPRINTS_CATEGORY");
    if (!blueprintCategories) {
      blueprintCategories = allBlueprintsCategories();
    }
    await setStorage("BLUEPRINTS_CATEGORY", blueprintCategories);
    return [200, blueprintCategories];
  });
  // Adding new blueprint Category
  mock.onPost(blueprintCategoryURL).reply(async (config) => {
    let newCategory = JSON.parse(config.data);
    let blueprintCategories = await getStorage("BLUEPRINTS_CATEGORY");
    blueprintCategories.push(createBlueprintCategory(newCategory));
    await setStorage("BLUEPRINTS_CATEGORY", blueprintCategories);
    return [200, blueprintCategories];
  });

  //Validating Blueprint Template
  const blueprintValidateURL = new RegExp(`${BLUEPRINTS_VALIDATE}`);
  mock.onPost(blueprintValidateURL).reply((config) => {
    return [200, "Success"];
  });

  // Import Custom Tasks
  const importTaskURL = new RegExp(
    `${ORG_APPLICATION_BASE_URL}.+${CUSTOM_TASKS_BASE_URL}`
  );
  mock.onPost(importTaskURL).reply(async (config) => {
    let configData = JSON.parse(config.data);
    if (configData && configData.TaskIds) {
      let importedTaskIds = await getStorage("IMPORTED_TASKS");
      if (!importedTaskIds) {
        importedTaskIds = configData;
      } else {
        importedTaskIds = {
          TaskIds: [...importedTaskIds.TaskIds, ...configData.TaskIds],
        };
      }
      await setStorage("IMPORTED_TASKS", importedTaskIds);
    } else {
      let tasksList = await getStorage("APP_CUSTOM_TASKS");
      if (!tasksList) {
        tasksList = [configData];
      } else {
        tasksList.push(configData);
      }
      await setStorage("APP_CUSTOM_TASKS", tasksList);
    }
    return [
      200,
      {
        Message: "Application Routine task added to the blueprint",
        Status: "Success",
      },
    ];
  });

  mock.onGet(importTaskURL).reply(async () => {
    let importedTaskIds = await getStorage("IMPORTED_TASKS");
    let tasksList = await getStorage("CUSTOM_TASKS");
    let appTasksList = (await getStorage("APP_CUSTOM_TASKS")) || [];
    if (!tasksList) {
      tasksList = allCustomTasks();
    }
    let importedTasks = tasksList.filter(
      (task) => importedTaskIds && importedTaskIds.TaskIds.includes(task.ID)
    );
    const allTasks = importedTasks.concat(appTasksList);
    return [200, preProcessImportedTasks(allTasks)];
  });

  const botTasksList = new RegExp(`${BOTS_BASE_URL}.+${TASKS_BASE_URL}`);

  mock.onGet(botTasksList).reply(async (config) => {
    const botId = config.url.split("bots/")[1].split("/tasks")[0];
    let tasks = allCustomTasks(botId);
    return [200, tasks];
  });

  const doesResourceExistUrl = new RegExp(`${RESOURCE_EXIST_URL}.+`);
  mock.onGet(doesResourceExistUrl).reply(() => {
    return [200, "true"];
  });

  const doResourcesExistUrl = new RegExp(`${RESOURCES_EXIST_URL}.+`);
  mock.onGet(doResourcesExistUrl).reply((config) => {
    const params = JSON.parse(decodeURI(config.url).split("=")[1]);
    const accounts = params && params.Accounts;
    let permissions = [];
    if (accounts && Array.isArray(accounts)) {
      permissions = accounts.map((acc) => {
        return {
          AccountNumber: acc,
          IsPermissionConfigured: true,
        };
      });
    }
    return [200, permissions];
  });

  // Custom Task

  const taskManifestURL = new RegExp(`${CUSTOM_TASKS_BASE_URL}.+/manifest`);

  mock.onGet(taskManifestURL).reply(async () => {
    let manifest = await getStorage("CUSTOM_TASK_MANIFEST");
    if (!manifest) {
      manifest = getCustomTaskManifest();
    }
    await setStorage("CUSTOM_TASK_MANIFEST", manifest);
    return [200, manifest];
  });

  const enableTask = new RegExp(`${CUSTOM_TASKS_BASE_URL}.+/enable`);

  mock.onPut(enableTask).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 2];
    let tasks = await getStorage("CUSTOM_TASKS");
    const updatedTasks = tasks.map((t) => {
      if (t.ID === id) {
        return { ...t, Enabled: JSON.parse(config.data).Enabled };
      }
      return t;
    });
    await setStorage("CUSTOM_TASKS", updatedTasks);
    return [200, {}];
  });

  const taskBaseURL = new RegExp(`${CUSTOM_TASKS_BASE_URL}.+`);

  mock.onGet(taskBaseURL).reply(async (config) => {
    if (decodeURI(config.url).includes("Filters")) {
      let tasks = await getStorage("CUSTOM_TASKS");
      if (!tasks) {
        tasks = allCustomTasks();
      }
      await setStorage("CUSTOM_TASKS", tasks);
      return [200, tasks];
    }
    const url = config.url.split("/");
    const id = url[url.length - 1];
    let tasks = await getStorage("CUSTOM_TASKS");
    if (!tasks) {
      tasks = allCustomTasks();
    }
    let task = tasks.find((t) => t.ID === id);
    if (!task) {
      task = getDesiredTaskDetails(id);
    }
    return [200, task];
  });

  mock.onDelete(taskBaseURL).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 1];
    let tasks = await getStorage("CUSTOM_TASKS");
    if (!tasks) {
      tasks = allCustomTasks();
    }
    const updatedTasks = tasks.filter((t) => t.ID !== id);
    await setStorage("CUSTOM_TASKS", updatedTasks);
    return [200, {}];
  });

  mock.onPost(taskBaseURL).reply(() => {
    return [200, { JobId: "1" }];
  });

  mock.onPost(CUSTOM_TASKS_BASE_URL).reply(() => {
    return [200, { JobId: "1" }];
  });

  // Reorder Tasks

  const reorderURL = new RegExp(
    `${ORG_APPLICATION_BASE_URL}.+${TASKS_BASE_URL}/${RE_ORDER}`
  );

  mock.onPut(reorderURL).reply((config) => {
    let configData = JSON.parse(config.data);
    reorderTasks(configData);
    return [200, {}];
  });

  // Update Task

  const updateTaskURL = new RegExp(
    `${ORG_APPLICATION_BASE_URL}.+${TASKS_BASE_URL}.+`
  );

  mock.onPut(updateTaskURL).reply((config) => {
    let configData = JSON.parse(config.data);
    updateTasks(configData);
    return [200, {}];
  });

  // Department List
  const departmentsURL = new RegExp(
    `${ORGANIZATION_BASE_URL}[0-9a-zA-Z-]+${DEPARTMENTS_BASE_URL}`
  );

  mock.onGet(departmentsURL).reply(async () => {
    let departments = await getStorage(ACTIVE_PROJECTS);
    if (!departments || Object.keys(departments).length === 0) {
      departments = getDepartmentsList();
    }
    await setStorage(ACTIVE_PROJECTS, departments);
    return [200, departments];
  });

  // mock.onGet(activeProjectsURL).reply(async () => {
  //   console.log("IN OLD");
  //   let departments = await getStorage("DEPARTMENTS");
  //   if (!departments) {
  //     const orgs = await getStorage("ORGANIZATIONS");
  //     departments = orgs[0].Departments;
  //   }
  //   const updatedDepartments = departments.map((dept) => {
  //     return {
  //       ...dept,
  //       Accounts: dept.Accounts.map((account) => {
  //         return {
  //           ...account,
  //           Regions:
  //             regions &&
  //             Array.isArray(regions) &&
  //             regions.map((region) => {
  //               return {
  //                 ...region,
  //                 Status: "CONNECTED",
  //               };
  //             }),
  //           Status: "CONNECTED",
  //         };
  //       }),
  //     };
  //   });
  //   await setStorage("DEPARTMENTS", updatedDepartments);
  //   return [200, updatedDepartments];
  // });

  //Project List

  const editProjectRequestApi = new RegExp(
    `${ORGANIZATION_BASE_URL}.+${REQUEST}/.+`
  );

  mock.onPut(editProjectRequestApi).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 1];
    const data = config.data && JSON.parse(config.data);
    let projectRequestsPending = await getStorage(PROJECT_REQUESTS_PENDING);
    if (data[STATE] === PENDING) {
      let requestIndex = projectRequestsPending.findIndex(
        (request) => request.ID === id
      );
      if (requestIndex >= 0) {
        let request = Object.assign({}, projectRequestsPending[requestIndex]);
        let updatedRequest = { ...request, ...data };
        projectRequestsPending[requestIndex] = updatedRequest;
        await setStorage(PROJECT_REQUESTS_PENDING, projectRequestsPending);
      }
    }
    if (data[STATE] === REJECTED_STATUS || data[STATE] === WITHDRAWN_STATUS) {
      let projectRequestsInactive = await getStorage(PROJECT_REQUESTS_INACTIVE);
      const requestIndex = projectRequestsInactive.findIndex(
        (request) => request.ID === id
      );
      if (requestIndex >= 0) {
        let request = Object.assign({}, projectRequestsInactive[requestIndex]);
        let updatedRequest = { ...request, ...data };
        updatedRequest[STATE] = PENDING;
        projectRequestsInactive.splice(requestIndex, 1);
        projectRequestsPending.push(updatedRequest);
        await setStorage(PROJECT_REQUESTS_INACTIVE, projectRequestsInactive);
        await setStorage(PROJECT_REQUESTS_PENDING, projectRequestsPending);
      }
    }

    return [200, { ID: id }];
  });

  const projectRequestIdApi = new RegExp(
    `${ORGANIZATION_BASE_URL}.+${REQUESTS}/.+`
  );

  mock.onPatch(projectRequestIdApi).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 1];
    const data = config.data && JSON.parse(config.data);
    let projectRequestsPending = await getStorage(PROJECT_REQUESTS_PENDING);

    //When project is approved
    if (data && data.hasOwnProperty(STATE)) {
      if (data[STATE] === APPROVED_STATUS) {
        let departments = await getStorage(ACTIVE_PROJECTS);

        let projectIndex = projectRequestsPending.findIndex(
          (request) => request.ID === id
        );

        if (!departments || Object.keys(departments).length === 0) {
          departments = getDepartmentsList();
        }
        if (projectIndex >= 0) {
          let request = Object.assign({}, projectRequestsPending[projectIndex]);
          projectRequestsPending.splice(projectIndex, 1);
          await setStorage(PROJECT_REQUESTS_PENDING, projectRequestsPending);
          departments.push(request);
          await setStorage(ACTIVE_PROJECTS, departments);
        }
        return [200, { ID: id }];
      }

      //When project is rejected
      if (data[STATE] === REJECTED_STATUS) {
        let projectRequestsInactive = await getStorage(
          PROJECT_REQUESTS_INACTIVE
        );

        let projectIndex = projectRequestsPending.findIndex(
          (request) => request.ID === id
        );
        if (projectIndex !== -1) {
          let request = Object.assign({}, projectRequestsPending[projectIndex]);
          projectRequestsPending.splice(projectIndex, 1);
          request[STATE] = REJECTED_STATUS;
          request[STATE_CHANGE_MESSAGE] = data[MESSAGE];
          projectRequestsInactive.push(request);
          await setStorage(PROJECT_REQUESTS_PENDING, projectRequestsPending);
          await setStorage(PROJECT_REQUESTS_INACTIVE, projectRequestsInactive);
        }
      }
      //When project is withdrawn
      if (data[STATE] === WITHDRAWN_STATUS) {
        let projectRequestsInactive = await getStorage(
          PROJECT_REQUESTS_INACTIVE
        );

        let projectIndex = projectRequestsPending.findIndex(
          (request) => request.ID === id
        );
        if (projectIndex !== -1) {
          let request = Object.assign({}, projectRequestsPending[projectIndex]);
          projectRequestsPending.splice(projectIndex, 1);
          request[STATE] = WITHDRAWN_STATUS;
          projectRequestsInactive.push(request);
          await setStorage(PROJECT_REQUESTS_PENDING, projectRequestsPending);
          await setStorage(PROJECT_REQUESTS_INACTIVE, projectRequestsInactive);
        }
      }
    }
    return [200, { ID: id }];
  });

  const projectRequestApi = new RegExp(`${ORGANIZATION_BASE_URL}.+${REQUESTS}`);

  mock.onGet(projectRequestApi).reply(async (config) => {
    const filters = JSON.parse(decodeURI(config.url).split("=")[1]);
    let projectRequests = [];
    let email = localStorage.getItem(EMAIL);
    if (
      filters[STATE].includes(PENDING) &&
      !DEMO_PROJECT_USERS.includes(email)
    ) {
      //Pending Projects
      let projectRequestsPending = await getStorage(PROJECT_REQUESTS_PENDING);
      if (!projectRequestsPending) {
        projectRequestsPending = getProjectRequestsPending();
        await setStorage(PROJECT_REQUESTS_PENDING, projectRequestsPending);
      }
      projectRequests = projectRequestsPending;
    }

    //Inactive Projects
    if (
      filters[STATE].includes(WITHDRAWN_STATUS) ||
      filters[STATE].includes(REJECTED_STATUS)
    ) {
      let projectRequestsInactive = await getStorage(PROJECT_REQUESTS_INACTIVE);
      if (!projectRequestsInactive) {
        projectRequestsInactive = getProjectRequestsInactive();
        await setStorage(PROJECT_REQUESTS_INACTIVE, projectRequestsInactive);
      }
      projectRequests = projectRequestsInactive;
    }

    return [200, projectRequests];
  });

  const createProjectRequestApi = new RegExp(
    `${ORGANIZATION_BASE_URL}.+${REQUEST}`
  );

  mock.onPost(createProjectRequestApi).reply(async (config) => {
    const data = config.data && JSON.parse(config.data);

    let projectRequestsPending = await getStorage(PROJECT_REQUESTS_PENDING);
    if (
      !projectRequestsPending ||
      Object.keys(projectRequestsPending).length === 0
    ) {
      projectRequestsPending = getProjectRequestsPending();
    }
    const newRequest = createProjectRequest(data);
    projectRequestsPending.push(newRequest);
    await setStorage(PROJECT_REQUESTS_PENDING, projectRequestsPending);
    return [200, { ID: newRequest.ID }];
  });

  // Application List

  const applicationsURL = new RegExp(
    `${ORGANIZATION_BASE_URL}.+${DEPARTMENT_BASE_URL}.+/applications`
  );

  mock.onGet(applicationsURL).reply(async () => {
    let applications = await getStorage("APPLICATIONS");
    if (!applications) {
      let application = await createApplication();
      applications = [application];
    }

    await setStorage("APPLICATIONS", applications);
    return [200, applications];
  });

  // App Resource Summary

  const appResourcesSummary = new RegExp(
    `${ORGANIZATION_BASE_URL}.+${DEPARTMENT_BASE_URL}.+${APPLICATION_BASE_URL}.+${SUMMARY_BASE_URL}`
  );

  mock.onGet(appResourcesSummary).reply(async (config) => {
    const words = config.url.split("/");
    const appId = words[words.length - 2];

    if (appId === TERRAFORM_ENV_ID) {
      return [
        200,
        {
          SecurityGroup: 1,
          S3: 4,
          Instance: 6,
          Volume: 8,
          IAMPolicy: 2,
          Lambda: 3,
          Rds: 3,
        },
      ];
    }

    return [200, resourceSummary];
  });

  // Environment List

  const environmentsURL = new RegExp(
    `${ORGANIZATION_BASE_URL}.+${DEPARTMENT_BASE_URL}.+${APPLICATION_BASE_URL}.+${ENVIRONMENTS_BASE_URL}`
  );

  mock.onGet(environmentsURL).reply(async () => {
    let environments = await getStorage("ENVIRONMENTS");
    if (!environments) {
      let environment = createEnvironment();
      environments = [environment];
    }

    await setStorage("ENVIRONMENTS", environments);
    return [200, environments];
  });

  // App Details

  const appDetailsURL = new RegExp(
    `${ORGANIZATIONS_BASE_URL}.+${DEPARTMENT_BASE_URL}.+${APPLICATION_BASE_URL}.+`
  );

  mock.onGet(appDetailsURL).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 1];
    let applications = await getStorage("APPLICATIONS");
    const application = applications.find((a) => a.ID === id);
    return [200, application];
  });

  // App Cost Details

  // Department Details
  const deptDetailsURL = new RegExp(
    `${ORGANIZATION_BASE_URL}.+${DEPARTMENT_BASE_URL}.+`
  );

  mock.onGet(deptDetailsURL).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 1];
    let departments = await getStorage(ACTIVE_PROJECTS);
    const department = departments.find((d) => d.ID === id);
    return [200, department];
  });

  mock.onPut(deptDetailsURL).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 1];
    const data = config.data && JSON.parse(config.data);
    let departments = await getStorage(ACTIVE_PROJECTS);
    const departmentIndex = departments.findIndex((d) => d.ID === id);

    if (departmentIndex !== -1) {
      let department = Object.assign({}, departments[departmentIndex]);
      let updatedDepartment = { ...department, ...data };
      departments[departmentIndex] = updatedDepartment;
      await setStorage(ACTIVE_PROJECTS, departments);
    }
    return [200, { ID: id }];
  });

  // User Data
  mock.onGet(GLOBAL_USER_DATA).reply(async () => {
    let u_data = await getStorage("USERDATA");
    if (!u_data) {
      u_data = await userdata();
    }
    await setStorage("USERDATA", u_data);
    return [200, u_data];
  });

  // Save User Data
  mock.onPost(GLOBAL_USER_DATA).reply(async (config) => {
    let userdata = JSON.parse(config.data);
    await setStorage("USERDATA", userdata);
    return [200, { jobId }];
  });

  /*
    Discover Instances
  */

  const orgSummaryUrl = new RegExp(`${ORGANIZATION_SUMMARY_URL}`);
  mock.onGet(orgSummaryUrl).reply(async (config) => {
    const completeQueryParams = decodeURI(config.url).split("Filters=");

    const filtersParams = completeQueryParams[1].split("&")[0];

    const fullParams = JSON.parse(filtersParams);

    const appId =
      fullParams.Apps && fullParams.Apps.length ? fullParams.Apps[0] : null;
    let resourceList = fullParams.ResourceType;
    let regionList = fullParams.Regions;
    let accountList = fullParams.Accounts;
    const isDiscoveryApi = fullParams.isDiscoveryApi;
    let count = 1,
      showOnlyCompletedStatus = true;
    if (isDiscoveryApi) {
      count = parseInt(await getStorage("DISCOVERY_COUNT"));
      await setStorage("DISCOVERY_COUNT", count ? count + 1 : 1);
      showOnlyCompletedStatus = count < 3;
      if (count >= 4) {
        await setStorage("DISCOVERY_COUNT", 1);
      }
    }
    let response = await organizationSummary(
      accountList,
      regionList,
      resourceList,
      showOnlyCompletedStatus
    );
    await setStorage("ORG_SUMMARY", response);
    if (appId) {
      let appTagResource = await getStorage("ADD_APP_RESOURCE");
      if (!appTagResource) {
        response = await appSummary(appId);
      } else if (appTagResource && appTagResource.length) {
        response = await appSummary(appId);
        let index = response.ResourceSummary.findIndex(
          (x) => x.ResourceType === "Instance"
        );
        response.ResourceSummary[index].ResourceCount++;
      }
    }
    return [200, response];
  });

  /* 
    Infrastructure - Compute - Instances
  */

  const getResourcesList = async ({ config, isPaginated = false }) => {
    const completeQueryParams = decodeURI(config.url).split("Filters=");
    const filtersParams = completeQueryParams[1].split("&")[0];
    const fullParams = JSON.parse(filtersParams);

    const deptId =
      fullParams.Depts && fullParams.Depts.length === 1
        ? fullParams.Depts[0]
        : null;
    const appId =
      fullParams.Apps && fullParams.Apps.length ? fullParams.Apps[0] : null;
    const envId =
      fullParams.Envs && fullParams.Envs.length ? fullParams.Envs[0] : null;
    const type = fullParams.ResourceType;
    const resourceId = fullParams.ResourceId;
    const selectedTag = fullParams.Tags;
    const accountList = fullParams.Accounts;
    const regionList = fullParams.Regions;
    const isDay2Managed = fullParams.IsDay2Managed;
    const isFirstRunView = fullParams.IsFirstRunView;
    const orgSummary = await getStorage("ORG_SUMMARY");
    let resources = await getStorage("RESOURCES");

    const tagList = await getStorage("TAGS");

    const getResponseStructure = (res) => {
      if (isPaginated) {
        return [200, { Items: res }];
      }

      return [200, res];
    };

    if (appId === TERRAFORM_ENV_ID) {
      let res;

      switch (type) {
        case resourceTypeCodes.S3:
          res = s3TerraformArray;
          break;
        case resourceTypeCodes.ROUTE_TABLE:
          res = routeTableTerraformArray;
          break;
        case resourceTypeCodes.SECURITY_GROUP:
          res = SecurityGroupTerraformArray;
          break;
        case resourceTypeCodes.VOLUME:
          res = VolumeTerraformArray;
          break;
        case resourceTypeCodes.RDS:
          res = RdsTerraformArray;
          break;
        default:
          res = null;
          break;
      }

      if (res) {
        return getResponseStructure(res);
      }
    }

    if (type) {
      if (type.includes(resourceTypeCodes.INSTANCE)) {
        let instanceCount = 3005;
        if (
          orgSummary &&
          orgSummary.ResourceSummary &&
          orgSummary.ResourceSummary.length > 0
        ) {
          instanceCount = orgSummary.ResourceSummary.filter(
            (ele) => ele.ResourceType === resourceTypeCodes.INSTANCE
          )[0].ResourceCount;
        }
        let instances = await getStorage("INSTANCES");
        if (!isArrayWithLength(instances)) {
          instances = await allInstances(
            instanceCount,
            accountList,
            regionList
          );
        }
        if (appId) {
          instances = instances.slice(0, 6);
        }
        if (isDay2Managed === false) {
          instances = instances.filter((instance) => !instance.IsDay2Managed);
        }
        await setStorage("INSTANCES", instances);
        return getResponseStructure(instances);
      } else if (type.includes(resourceTypeCodes.WORKSPACE)) {
        const workspaceCount =
          (appId &&
            orgSummary &&
            isArrayWithLength(orgSummary.ResourceSummary) &&
            orgSummary.ResourceSummary.filter(
              (ele) => ele.ResourceType === resourceTypeCodes.WORKSPACE
            )[0].ResourceCount) ||
          20;
        let workspaces = await getStorage("WORKSPACES");
        if (!workspaces) {
          workspaces = await allWorkspaces(workspaceCount);
        }
        await setStorage("WORKSPACES", workspaces);
        return getResponseStructure(workspaces.slice(0, workspaceCount));
      } else if (type.includes(resourceTypeCodes.IMAGE)) {
        let imageCount = 200;
        if (
          orgSummary &&
          orgSummary.ResourceSummary &&
          orgSummary.ResourceSummary.length > 0
        ) {
          imageCount = orgSummary.ResourceSummary.filter(
            (ele) => ele.ResourceType === resourceTypeCodes.IMAGE
          )[0].ResourceCount;
        }
        let images = await getStorage("IMAGES");
        if (!images) {
          images = await allImages(imageCount, accountList, regionList);
        }
        await setStorage("IMAGES", images);
        return getResponseStructure(images);
      } else if (type.includes(resourceTypeCodes.VOLUME)) {
        let volumes = await allVolumes();
        if (appId) {
          volumes = volumes.slice(0, 8);
        }
        return getResponseStructure(volumes);
      } else if (type.includes(resourceTypeCodes.SNAPSHOT)) {
        let snapshots = await getStorage("SNAPSHOTS");
        if (!snapshots) {
          snapshots = await allSnapshots();
        }
        await setStorage("SNAPSHOTS", snapshots);
        return getResponseStructure(snapshots);
      } else if (type.includes(resourceTypeCodes.CLOUDWATCH_EVENT_RULE)) {
        let CloudWatchEventRules = await getStorage("CLOUDWATCHEVENTS");
        if (!CloudWatchEventRules) {
          CloudWatchEventRules = await allCoudWatchEventRules();
        }
        await setStorage("CLOUDWATCHEVENTS", CloudWatchEventRules);
        return getResponseStructure(CloudWatchEventRules);
      } else if (type.includes(resourceTypeCodes.SUBNET)) {
        let subnets = await getStorage("SUBNETS");
        if (!subnets) {
          subnets = await allSubnets();
        }
        if (appId) {
          subnets = subnets.slice(0, 4);
        }
        await setStorage("SUBNETS", subnets);
        return getResponseStructure(subnets);
      } else if (type.includes(resourceTypeCodes.SECURITY_GROUP)) {
        let securityGroups = await getStorage("SECURITYGROUP");
        if (!securityGroups) {
          securityGroups = await allSecurityGroups();
        }
        if (appId) {
          securityGroups = securityGroups.slice(0, 1);
        }

        await setStorage("SECURITYGROUP", securityGroups);

        return getResponseStructure(securityGroups);
      } else if (type.includes(resourceTypeCodes.VPC)) {
        let vpcCount = 30;
        if (
          orgSummary &&
          orgSummary.ResourceSummary &&
          orgSummary.ResourceSummary.length > 0
        ) {
          vpcCount = orgSummary.ResourceSummary.filter(
            (ele) => ele.ResourceType === resourceTypeCodes.VPC
          )[0].ResourceCount;
        }
        const vpcs = await allVpcs(vpcCount, accountList, regionList);
        await setStorage("VPCS", vpcs);

        return getResponseStructure(vpcs);
      } else if (type.includes(resourceTypeCodes.CFN)) {
        let cfnCount = 15;
        if (
          orgSummary &&
          orgSummary.ResourceSummary &&
          orgSummary.ResourceSummary.length > 0
        ) {
          cfnCount = orgSummary.ResourceSummary.filter(
            (ele) => ele.ResourceType === resourceTypeCodes.CFN
          )[0].ResourceCount;
        }
        const cfns = await allCfns(cfnCount, accountList, regionList);
        await setStorage("CFNS", cfns);
        return getResponseStructure(cfns);
      } else if (type.includes(resourceTypeCodes.IAM_ROLE)) {
        let iamRoles = await allIAMRoles();
        return getResponseStructure(iamRoles);
      } else if (type.includes(resourceTypeCodes.KEY_PAIR)) {
        let keyPairs = allKeyPairs();
        return getResponseStructure(keyPairs);
      } else if (type.includes(resourceTypeCodes.LAMBDA)) {
        let lambdas = allLambdas(deptId, appId, envId);
        return getResponseStructure(lambdas);
      } else if (type.includes(resourceTypeCodes.S3)) {
        let s3Buckets = allS3Buckets(deptId, appId, envId);
        return getResponseStructure(s3Buckets);
      } else if (type.includes(resourceTypeCodes.IAM_POLICY)) {
        let iamPolicies = allIAMPolicies(deptId, appId, envId);
        return getResponseStructure(iamPolicies);
      } else if (type.includes(resourceTypeCodes.CUSTOMER_ACCOUNT)) {
        let accounts = await getStorage("ACCOUNTS");
        if (!accounts) {
          accounts = getAllAccounts();
          await setStorage("ACCOUNTS", accounts);
        }
        const data = JSON.parse(config.data);
        if (deptId) {
          let deptAccounts = [];
          accounts.forEach((item) => {
            fullParams.Depts.forEach((dept) => {
              if (dept === item.DepartmentId) {
                deptAccounts.push(item);
              }
            });
          });
          // accounts = deptAccounts;
          accounts = [...new Set(deptAccounts)];
        }
        if (isFirstRunView) {
          const _accounts =
            isArrayWithLength(accounts) &&
            accounts.filter((acc) => acc.IsFirstRunView);
          accounts = _accounts;
        }
        if (data.AccountNumber) {
          const accountData = accounts.find(
            (item) => data.AccountNumber === item.AccountNumber
          );
          accounts = { Data: accountData };
        }
        return getResponseStructure(accounts);
      } else if (type.includes(resourceTypeCodes.TOPIC)) {
        const snsTopics = getSnsTopics();
        return getResponseStructure(snsTopics);
      } else if (type.includes(resourceTypeCodes.ROUTE_TABLE)) {
        return getResponseStructure(routeTableTerraformArray);
      }
    } else if (resourceId) {
      if (resourceId.includes("vpc")) {
        let vpcs = await getStorage("VPCS");

        const selectedVpc = vpcs.find((vpc) => vpc.ResourceId === resourceId);
        if (!resources) {
          resources = await getResources();
          await setStorage("RESOURCES", resources);
        }
        const vpcResourceList = vpcResources(selectedVpc, resources);
        return getResponseStructure(vpcResourceList);
      } else {
        let cfns = await getStorage("CFNS");
        const selectedCfn = cfns.find((cfn) => cfn.ResourceId === resourceId);
        if (!resources) {
          resources = await getResources();
          await setStorage("RESOURCES", resources);
        }
        const cfnResourceList = cfnResources(selectedCfn, resources);
        return getResponseStructure(cfnResourceList);
      }
    } else if (selectedTag) {
      let tagCount = 89;
      let tagResources;
      if (!resources) {
        resources = await getResources();
        await setStorage("RESOURCES", resources);
      }
      const shuffledResources = resources.sort(() => 0.5 - Math.random());
      if (tagList && selectedTag.length && selectedTag[0].Value) {
        const selectedTagDetails = tagList.find(
          (tag) => tag.Value === selectedTag[0].Value
        );
        tagResources = getResourcesforTags(
          selectedTagDetails,
          shuffledResources
        );
      } else {
        tagResources = shuffledResources.slice(0, tagCount);
      }
      return getResponseStructure(tagResources);
    } else if (fullParams.Orgs && fullParams.Apps && fullParams.Envs) {
      const appId = fullParams.Apps[0];
      if (!resources) {
        resources = await getResources();
        await setStorage("RESOURCES", resources);
      }
      let filteredResources = [];
      if (appId === "001" || appId === "1") {
        let appTagResource = await getStorage("ADD_APP_RESOURCE");
        let appResources = ecsClusterResources();
        let allResources =
          appTagResource && appTagResource.length
            ? [...appTagResource, ...appResources]
            : appResources;
        allResources &&
          allResources.forEach((res) => {
            res.ApplicationId = appId;
            res.EnvironmentId = envId;
            filteredResources.push(res);
          });
      } else {
        filteredResources = resources.filter(
          (item) => item.ApplicationId === appId
        );
      }
      return getResponseStructure(filteredResources);
    } else if (fullParams.Orgs && fullParams.Depts) {
      let departmentList = JSON.parse(
        decodeURI(config.url).split("Filters=")[1]
      ).Depts;

      if (!resources) {
        resources = await getResources();
        await setStorage("RESOURCES", resources);
      }
      let filteredResouces;
      if (departmentList && departmentList.length) {
        filteredResouces = resources.filter((item) =>
          departmentList.includes(item.DepartmentId)
        );
      } else {
        filteredResouces = resources.filter(
          (item) => item.DepartmentId === deptId
        );
      }
      return getResponseStructure(filteredResouces);
    } else if (fullParams.Orgs) {
      if (!resources) {
        resources = await getResources();
        await setStorage("RESOURCES", resources);
      }

      return getResponseStructure(resources);
    } else if (fullParams.Apps && fullParams.Envs) {
      if (!resources) {
        resources = await getResources();
        await setStorage("RESOURCES", resources);
      }
      let filteredResouces = resources.filter(
        (item) => item.EnvironmentId === envId
      );
      return getResponseStructure(filteredResouces);
    }
  };

  const getAllPaginatedResources = new RegExp(
    `${RESOURCES_LIST_PAGINATED_URL}.+`
  );

  mock.onGet(getAllPaginatedResources).reply(async (config) => {
    return getResourcesList({ config, isPaginated: true });
  });

  // Instance, Volume, Snapshot List
  const getAllResources = new RegExp(`${RESOURCES_LIST_URL}.+`);

  mock.onGet(getAllResources).reply(async (config) => {
    return getResourcesList({ config, isPaginated: false });
  });

  // DAS

  mock.onPost(CUSTOMER_ACCOUNT_STATE).reply(async (config) => {
    const data = JSON.parse(config.data);
    const accountNumber = data && data.AccountNumber;
    await setDASStatus(accountNumber);
    return [200, {}];
  });

  // DRS

  mock.onPost(CUSTOMER_REGION_STATE).reply(() => {
    return [200, {}];
  });

  // Update Tags
  const updateTagsURL = new RegExp(`${ORG_RESOURCE_TAGS_URL}`);

  mock.onPost(updateTagsURL).reply(async (config) => {
    const data = JSON.parse(config.data);
    const resourceId =
      data.ResourceIds && data.ResourceIds.length && data.ResourceIds[0];
    const resources = await getStorage("INSTANCES");
    const index = resources.findIndex((res) => res.ResourceId === resourceId);
    if (index > -1) {
      resources[index].Tags = [...resources[index].Tags, ...data.Tags.Add];
      await setStorage("INSTANCES", resources);
      let selectedResource = resources[index];
      selectedResource.ResourceType = resourceTypeCodes.INSTANCE;
      selectedResource.ApplicationId = "default";
      selectedResource.AccountNumber = "904433914959";
      selectedResource.ARN =
        "arn:aws:instance:us-east-1:904433914959:stack-2020-06-03-14-46-31-Instance2-1P6UO3831QL9Z";
      selectedResource.Region = selectedResource.RegionCode;
      await setStorage("ADD_APP_RESOURCE", [selectedResource]);
      //create Notification
      let newNotification = await createNotification(selectedResource);

      let notificationList = await getStorage("NOTIFICATIONS_LIST");
      if (!notificationList) {
        notificationList = getNotificationList();
      } else {
        notificationList.notifications.unshift(newNotification);
        notificationList.openCount = 1;
      }
      await setStorage("NOTIFICATIONS_LIST", notificationList);
      return [200, selectedResource];
    }
    return [200, {}];
  });

  //activation

  mock.onGet(GET_HYBRID_ACTIVATION_ROLE_DETAILS).reply(async () => {
    let activationRoles = await getStorage(
      "GET_HYBRID_ACTIVATION_ROLE_DETAILS"
    );
    if (!activationRoles) {
      activationRoles = getActivationRoleDetails();
    }
    await setStorage("GET_HYBRID_ACTIVATION_ROLE_DETAILS", activationRoles);
    return [200, activationRoles];
  });

  mock.onPost(GET_ACTIVATION_CODE).reply(async () => {
    let activation = await getStorage("GET_ACTIVATION_CODE");
    if (!activation) {
      activation = await getActivationCode();
    }
    await setStorage("GET_ACTIVATION_CODE", activation);
    return [200, activation];
  });

  // Get Patch Details

  const patchDetails = new RegExp(`${EC2_INSTANCE_BASE_URL}.+${PATCHES}`);

  mock.onGet(patchDetails).reply(async () => {
    const patches = patchStates();
    return [200, { Patches: patches }];
  });

  // Instance Actions
  const instanceURL = new RegExp(`${EC2_INSTANCE_BASE_URL}`);

  mock.onPost(instanceURL).reply(async (config) => {
    const instances = await getStorage("INSTANCES");
    const data = JSON.parse(config.data);
    const action = data.Action;
    const instanceIds = data.ResourceIds;
    if (instanceIds) {
      const newInstances = changeState(action, instanceIds, instances);
      await setStorage("INSTANCES", newInstances);
    }
    const JobId = uuidv4();
    let jobs = await getStorage("JOBS");
    if (!jobs) {
      jobs = await allJobs();
    }
    let newJobs = addInstanceJob(data, jobs, JobId);
    await setStorage("JOBS", newJobs);
    return [200, { JobId: JobId }];
  });

  // Workspace Actions
  const workspaceURL = new RegExp(`${WORKSPACES_BASE_URL}`);

  mock.onPost(workspaceURL).reply(async () => {
    return [200, {}];
  });

  // Volume Actions
  const volumeURL = new RegExp(`${VOLUMES_BASE_URL}`);

  mock.onPost(volumeURL).reply(async () => {
    return [200, {}];
  });

  // RDP

  const getRDPConfig = new RegExp(
    `${EC2_INSTANCE_BASE_URL}.+${RDP_CONFIG_URL}`
  );
  mock.onGet(getRDPConfig).reply(async () => {
    const rdpConfig = await getStorage("RDP_CONFIG");
    let data;
    if (rdpConfig) {
      data = JSON.parse(rdpConfig);
      data = {
        ...data,
        ConfigExists: true,
      };
    } else {
      data = {
        ConfigExists: false,
        CFNPath: cfnPath,
      };
    }
    await setStorage("RDP_CONFIG", data);
    return [200, data];
  });

  // Instance Details

  const detectCloudWatchAgent = new RegExp(
    `${EC2_INSTANCE_BASE_URL}.+${PACKAGES}`
  );

  mock.onGet(detectCloudWatchAgent).reply(() => {
    return [200, detectCloudWatchAgentData];
  });

  const checkCloudWatchUserExist = new RegExp(
    `${EC2_INSTANCE_BASE_URL}.+${PACKAGE_CLOUD_WATCH}`
  );

  mock.onGet(checkCloudWatchUserExist).reply(() => {
    return [200, checkCloudWatchUserExistData];
  });

  const getInstanceMetrics = new RegExp(
    `${ORG_RESOURCE_BASE_URL}.+${METRICS}/${LIST}`
  );
  mock.onGet(getInstanceMetrics).reply(async () => {
    let metricsData = await getStorage("INSTANCE_MONITORING");
    if (!metricsData) {
      metricsData = monitoringMetric();
    }
    return [200, metricsData];
  });

  const getInstanceMetricsData = new RegExp(
    `${ORG_RESOURCE_BASE_URL}.+${METRICS}?.+`
  );

  mock.onGet(getInstanceMetricsData).reply((config) => {
    let result = getMonitoringMetricData(config);
    return [200, result];
  });

  // Instance Details

  // Get Instance Types

  const instanceTypesURL = new RegExp(`${EC2_INSTANCE_LIST_URL}${TYPES}.+`);

  mock.onGet(instanceTypesURL).reply(() => {
    const types = [
      "m5.xlarge",
      "t2.micro",
      "t3.micro",
      "t2.nano",
      "t2.small",
      "t2.medium",
      "t2.large",
      "t2.xlarge",
      "t2.2xlarge",
    ];
    return [200, types];
  });

  mock.onGet(instanceURL).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 1];
    let instances = await getStorage("INSTANCES");

    if (!isArrayWithLength(instances)) {
      const newInstances = await allInstances(10);
      await setStorage("INSTANCES", newInstances);
      instances = newInstances;
    }

    let instance =
      isArrayWithLength(instances) &&
      instances.find((instance) => id === instance.ResourceId);

    if (!instance && isArrayWithLength(instances)) {
      instance = instances[0];
    }
    const instanceDetails = instanceData(instance);
    return [200, instanceDetails];
  });

  const appDetails = new RegExp(`${APPLICATIONS_BASE_URL}/.+`);
  mock.onGet(appDetails).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 1];

    let applications = await getStorage("APPLICATIONS");
    if (!isArrayWithLength(applications)) {
      applications = allApplications();
      await setStorage("APPLICATIONS", applications);
    }

    let appDetails = applications.find((app) => app.ID === id);

    if (appDetails) {
      return [200, appDetails];
    } else {
      return [404, {}];
    }
  });

  const allApps = new RegExp(`${APPLICATIONS_BASE_URL}.+`);

  mock.onGet(allApps).reply(async (config) => {
    const filters = JSON.parse(decodeURI(config.url).split("Filters=")[1]);
    let applications = await getStorage("APPLICATIONS");
    if (!isArrayWithLength(applications)) {
      applications = allApplications();
      await setStorage("APPLICATIONS", applications);
    }
    if (filters) {
      if (filters["Depts"]) {
        let filteredApps = applications.filter(
          (app) => app.DepartmentId === filters["Depts"][0]
        );
        return [200, filteredApps];
      }
    }

    return [200, applications];
  });

  // Workspace Details

  const getWorkspaceDetails = new RegExp(`${ORG_RESOURCE_BASE_URL}.+`);

  mock.onGet(getWorkspaceDetails).reply(async (config) => {
    const resourceId = decodeURI(config.url).split("ResourceId=")[1];
    const workspaces = await getStorage("WORKSPACES");
    let workspace =
      isArrayWithLength(workspaces) &&
      workspaces.find((ws) => resourceId === ws.WorkspaceId);
    if (!workspace) {
      workspace = isArrayWithLength(workspaces) ? workspaces[0] : {};
    }
    return [200, workspace];
  });

  /* 
  
    Infrastructure - Compute - Images(AMI)

  */

  // Image List & Details

  mock.onPost(AMI_LIST_URL).reply(async () => {
    let images = await getStorage("IMAGES");
    if (!images) {
      images = await allImages();
    }
    await setStorage("IMAGES", images);
    return [200, images];
  });

  mock.onPost(RESOURCE_TAGS_URL).reply(async (config) => {
    const data = JSON.parse(config.data);
    if (data.Operation === "getTagList") {
      let tagList = await getStorage("TAGS");
      if (!tagList) {
        tagList = await getAllTags();
      }
      await setStorage("TAGS", tagList);
      return [200, tagList];
    }
  });

  const iamRoleDetailsUrl = new RegExp(`${IAM_ROLE_POLICIES}.+`);
  mock.onGet(iamRoleDetailsUrl).reply((config) => {
    const filters = JSON.parse(decodeURI(config.url).split("Filter=")[1]);
    const roleDetails = getIamRoleDetails(filters["Arn"]);
    return [200, roleDetails];
  });

  /* 
  
    Tasks

  */

  // Schedules

  mock.onGet(`${SCHEDULED_TASKS_LIST_URL}`).reply(async () => {
    let schedules = await getStorage("SCHEDULES");
    if (!schedules) {
      schedules = allSchedules();
    }
    await setStorage("SCHEDULES", schedules);
    return [200, schedules];
  });

  // History / Jobs

  mock.onGet(JOBS_LIST_URL).reply(async () => {
    let jobs = await getStorage("JOBS");
    if (!jobs) {
      jobs = await allJobs();
    }
    await setStorage("JOBS", jobs);
    return [200, jobs];
  });

  const taskUrl = new RegExp(`${SCHEDULED_TASKS_LIST_URL}.+`);

  mock.onGet(taskUrl).reply(async (config) => {
    let schedules = await getStorage("SCHEDULES");
    if (!schedules) {
      schedules = allSchedules();
      await setStorage("SCHEDULES", schedules);
    }
    let filteredSchedules = schedules;
    const category = config.url.split("Category")[1];
    if (category) {
      if (category.includes(["PATCH-SCAN"])) {
        filteredSchedules = schedules.filter(
          (item) => item.Category === "PATCH-SCAN"
        );
      } else if (category.includes(["DESIRED-SERVER-STATE"])) {
        filteredSchedules = schedules.filter(
          (item) => item.Category === "DESIRED-SERVER-STATE"
        );
      } else if (category.includes(["PATCH-INSTALL"])) {
        filteredSchedules = schedules.filter(
          (item) => item.Category === "PATCH-INSTALL"
        );
      } else if (category.includes(["Script"])) {
        //currently there is no mock data for scripts
        filteredSchedules = schedules.filter(
          (item) => item.Category === "Script"
        );
      }
    }
    return [200, { Items: filteredSchedules }];
  });

  const jobUrl = new RegExp(`${JOBS_LIST_URL}.+`);

  mock.onGet(jobUrl).reply(async (config) => {
    let jobs = await getStorage("JOBS");
    if (!jobs) {
      jobs = await allJobs();
      await setStorage("JOBS", jobs);
    }
    const category = config.url.split("Category")[1];
    let filteredJobs = jobs;
    if (category) {
      if (category.includes(["PATCH-SCAN"])) {
        filteredJobs = jobs.filter((item) => item.Category === "PATCH-SCAN");
      } else if (category.includes(["DESIRED-SERVER-STATE"])) {
        filteredJobs = jobs.filter(
          (item) => item.Category === "DESIRED-SERVER-STATE"
        );
      } else if (category.includes(["PATCH-INSTALL"])) {
        filteredJobs = jobs.filter((item) => item.Category === "PATCH-INSTALL");
      } else if (category.includes(["Script"])) {
        //currently there is no mock data for scripts
        filteredJobs = jobs.filter((item) => item.Category === "Script");
      }
    }
    return [200, { Items: filteredJobs }];
  });

  /* 
  
    Operations - Patch Management - Server Groups

  */

  // Server Group List

  mock.onPost(SERVER_GROUPS_BASE_URL).reply(async () => {
    let serverGroups = await getStorage("SERVER_GROUPS");
    if (!serverGroups) {
      serverGroups = allServerGroups();
    }
    await setStorage("SERVER_GROUPS", serverGroups);
    return [200, serverGroups];
  });

  // Server Group Details - Instances

  const serverGroupInstancesURL = new RegExp(`${SERVER_GROUP_BASE_URL}.+`);

  mock.onPost(serverGroupInstancesURL).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 1];
    let serverGroups = await getStorage("SERVER_GROUPS");
    const group = serverGroups.find((item) => id === item.ServerGroupId);
    const serverGroupInstances = await allServerGroupInstances(group);
    return [200, serverGroupInstances];
  });

  // Save server group

  mock.onPost(SERVER_GROUP_BASE_URL).reply(async (config) => {
    const data = JSON.parse(config.data);
    let serverGroups = await getStorage("SERVER_GROUPS");
    serverGroups.push(createServerGroup(data));
    await setStorage("SERVER_GROUPS", serverGroups);
    return [
      200,
      { Status: "Success", Message: "Server Group added successfully" },
    ];
  });

  // Desire State Policy List and Desire State Policy Details

  const dssListing = new RegExp(`${DESIRED_STATE_POLICIES_LIST_URL}?.+`);
  mock.onGet(dssListing).reply(async (config) => {
    const urlDetails = config.url.split("?")[0].split("policies/");
    let desiredStatePolicies = await getStorage("DESIRED_STATE_POLICIES");
    if (urlDetails.length === 2) {
      const id = urlDetails[1];
      const desiredStatePolicy = desiredStatePolicies.find(
        (desiredStatePolicy) => id === desiredStatePolicy.ID
      );
      const desiredStatePolicyDetails =
        desiredStatePolicyData(desiredStatePolicy);
      return [200, desiredStatePolicyDetails];
    } else {
      if (!desiredStatePolicies) {
        desiredStatePolicies = await allDesiredStatePolicies();
      }
      await setStorage("DESIRED_STATE_POLICIES", desiredStatePolicies);
      return [200, desiredStatePolicies];
    }
  });

  // Save Desired State Policy
  const dssCUD = new RegExp(`${DESIRED_STATE_POLICY_SAVE_URL}`);

  mock.onPut(dssCUD).reply(async (config) => {
    let updatedPolicy = [];
    const newData = JSON.parse(config.data);
    let newPolicy = await saveDesiredPolicyData(newData);
    let dsPolicies = await getStorage("DESIRED_STATE_POLICIES");
    updatedPolicy = dsPolicies.filter((policy) => newData.ID !== policy.ID);
    updatedPolicy.push(newPolicy);
    await setStorage("DESIRED_STATE_POLICIES", updatedPolicy);
    return [
      200,
      {
        Status: "Success",
        Message: "Desired State policy template has been saved successfully",
      },
    ];
  });

  // Create Desired State Policy
  mock.onPost(dssCUD).reply(async (config) => {
    const newData = JSON.parse(config.data);
    let newPolicy = await saveDesiredPolicyData(newData);
    let dsPolicies = await getStorage("DESIRED_STATE_POLICIES");
    dsPolicies.push(newPolicy);
    await setStorage("DESIRED_STATE_POLICIES", dsPolicies);
    return [
      200,
      {
        Status: "Success",
        Message: "Desired State policy template has been created successfully",
      },
    ];
  });

  //delete deisred state policy
  mock.onDelete(dssCUD).reply(async (config) => {
    const url = config.url.split("policies/");
    const id = url[url.length - 1];
    const remainingDesiredStatePolicies = [];
    const desiredStatePolicies = await getStorage("DESIRED_STATE_POLICIES");
    desiredStatePolicies.map((desiredStatePolicy) => {
      return (
        id !== desiredStatePolicy.ID &&
        remainingDesiredStatePolicies.push(desiredStatePolicy)
      );
    });
    await setStorage("DESIRED_STATE_POLICIES", remainingDesiredStatePolicies);
    return [
      200,
      {
        message: "successfully Deleted Desired State policy",
      },
    ];
  });

  // Patch Policy List

  mock.onPost(PATCH_POLICIES_LIST_URL).reply(async () => {
    let patchPolicies = await getStorage("PATCH_POLICIES");
    if (!patchPolicies) {
      patchPolicies = await allPatchPolicies();
    }
    await setStorage("PATCH_POLICIES", patchPolicies);
    return [200, patchPolicies];
  });

  // Patch List
  const getPatchList = new RegExp(`${PATCHES_PATCHLIST_URL}`);
  mock.onPost(getPatchList).reply(async (config) => {
    if (decodeURI(config.url).split("windows")[1].includes("patches")) {
      let patches = await getStorage("PATCHES");
      if (!patches) {
        patches = allPatches();
      }
      await setStorage("PATCHES", patches);
      return [200, patches];
    }
  });

  // Save Patch Policy
  const savePatchList = new RegExp(`${PATCH_POLICY_SAVE_URL}`);
  mock.onPost(savePatchList).reply(async (config) => {
    const newPatchData = JSON.parse(config.data);
    let newPatch = await savePolicyData(newPatchData);
    let patchPolicies = await getStorage("PATCH_POLICIES");
    patchPolicies.push(newPatch);
    await setStorage("PATCH_POLICIES", patchPolicies);
    return [
      200,
      {
        Status: "Success",
        Message: "Patch policy template has been saved successfully",
      },
    ];
  });

  // New Job Schedules(Later)
  const scheduleJobBaseUrl = new RegExp(`${SCHEDULE_BASE_URL}`);
  mock.onPost(scheduleJobBaseUrl).reply(async (config) => {
    const data = JSON.parse(config.data);
    const newScheduledJob = createNewSchedule(data);
    const allSchedules = await getStorage("SCHEDULES");
    allSchedules.unshift(newScheduledJob);
    await setStorage("SCHEDULES", allSchedules);
    return [200, "Success"];
  });

  // Vulnerability Scanning - New Scan - Schedules(Later)
  const scheduleBaseUrl = new RegExp(`${SCHEDULE_BASE_URL}.+`);
  mock.onGet(scheduleBaseUrl).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 1];
    if (id === "jobs") {
      let schedule = [];
      schedule.push(await getScanJobs(url[url.length - 2]));
      return [200, schedule];
    } else {
      const allSchedules = await getStorage("SCHEDULES");
      let schedule = allSchedules.find((item) => item.ScheduleId === id);

      return [200, schedule];
    }
  });

  //JOB_SCHEDULE_BASE_URL
  const singleJobBaseUrl = new RegExp(`${JOB_SCHEDULE_BASE_URL}[0-9a-zA-Z-]+$`);
  mock.onGet(singleJobBaseUrl).reply(async (config) => {
    const url = config.url.split("/");
    const jobId = url.at(-1);
    let jobs = await getStorage("JOBS");
    const requiredJob = isArrayWithLength(jobs)
      ? jobs.find((obj) => obj.JobId === jobId)
      : null;
    let jobTasks = requiredJob ? getAllJobTasks(requiredJob)[0] : [];
    return [200, jobTasks];
  });

  const jobScheduleBaseUrl = new RegExp(
    `${JOB_SCHEDULE_BASE_URL}[0-9a-zA-Z-]+${TASKS_BASE_URL}$`
  );

  mock.onGet(jobScheduleBaseUrl).reply(async (config) => {
    const url = config.url.split("/");
    const jobId = url.at(-2);
    let jobs = await getStorage("JOBS");
    const requiredJob = isArrayWithLength(jobs)
      ? jobs.find((obj) => obj.JobId === jobId)
      : null;

    let jobTasks = requiredJob ? getAllJobTasks(requiredJob, true) : [];
    const response = { Items: jobTasks };

    return [200, response];
  });

  /* 
    Settings - Integrations
  */

  // Desired State Execution - Delete Schedules
  const deleteSchedule = new RegExp(`${SCHEDULE_BASE_URL}.+`);
  mock.onDelete(deleteSchedule).reply(async (config) => {
    const url = config.url.split("schedule/");
    const id = url[url.length - 1];
    const remainingSceduledjobs = [];
    const scheduledJobs = await getStorage("SCHEDULES");
    scheduledJobs.map((job) => {
      return id !== job.ScheduleId && remainingSceduledjobs.push(job);
    });

    await setStorage("SCHEDULES", remainingSceduledjobs);
    return [200, "Deleted schueduled task"];
  });

  // Integration List

  const integrationsURL = new RegExp(`${INTEGRATIONS_BASE_URL}${SUMMARY}`);

  mock.onGet(integrationsURL).reply(() => {
    let integrations = allIntegrations();
    return [200, integrations];
  });

  // Integration List

  const integrationsSpecificationURL = new RegExp(
    `${INTEGRATIONS_BASE_URL}${SPECIFICATION}`
  );

  mock.onGet(integrationsSpecificationURL).reply(async (config) => {
    const filters = JSON.parse(decodeURI(config.url).split("Filters=")[1]);
    let items = await getIntegrationSpec(filters.Service);
    return [200, items];
  });

  // Integration Items

  const integrationURL = new RegExp(`${INTEGRATIONS_BASE_URL}.+`);

  mock.onGet(integrationURL).reply(async (config) => {
    const filters = JSON.parse(decodeURI(config.url).split("Filters=")[1]);
    let items = await allIntegrationsItems(filters.Service);
    return [200, items];
  });

  // Create Integration

  mock.onPost(integrationURL).reply(() => {
    return [200, {}];
  });

  // Edit Integration

  mock.onPut(integrationURL).reply(() => {
    return [200, {}];
  });

  // Delete Integration

  mock.onDelete(integrationURL).reply(() => {
    return [200, {}];
  });

  // SSO

  // get profile id
  mock.onGet(SSO_ACTIVE_SETTINGS).reply(async () => {
    const activeSettings = await getSSOActiveSettings();
    return [200, activeSettings];
  });

  // get roles
  mock.onGet(SSO_APPLICATION_ROLES).reply(() => {
    const roles = getSSORoles();
    return [200, roles];
  });

  // set and get sso configuration id
  mock.onPost(SSO_CONFIGURATION).reply(async (config) => {
    const configData = JSON.parse(config.data);
    const ssoConfigurationId = uuidv4();
    await initiateSSO(ssoConfigurationId, configData);
    return [
      200,
      {
        Id: ssoConfigurationId,
        DomainVerificationTxtCode: domainVerificationTxtCode,
      },
    ];
  });

  // get all sso configurations
  mock.onGet(SSO_CONFIGURATIONS).reply(async () => {
    let ssoConfig = await getStorage("SSO_CONFIG");
    let config = ssoConfig;
    if (!ssoConfig) {
      config = [];
    } else {
      if (!Array.isArray(config)) {
        config = [config];
      }
    }
    await setStorage("SSO_CONFIG", ssoConfig);
    return [200, config];
  });

  // save sso configuration changes - idp, change mgmt status
  const saveSSOConfiguration = new RegExp(`${SSO_CONFIGURATION}.+`);
  mock.onPut(saveSSOConfiguration).reply(async (config) => {
    const configData = JSON.parse(config.data);
    await editConfig(configData);
    return [200, {}];
  });

  // disable SSO
  mock.onPost(saveSSOConfiguration).reply(async () => {
    const isDisable = true;
    await editConfig(null, isDisable);
    return [200, {}];
  });

  // is sso enabled
  mock.onGet(SSO_ENABLED_URL).reply(async () => {
    const ssoConfig = await getStorage("SSO_CONFIG");
    const status = ssoConfig && ssoConfig.MgmtStatus === "ENABLED";
    return [200, { SSOEnabled: status }];
  });

  // delete config
  const deleteSSOApi = new RegExp(`${SSO_CONFIGURATION}.+`);
  mock.onDelete(deleteSSOApi).reply(async () => {
    await removeItem("SSO_CONFIG");
    await removeItem("CUSTOMER_DOMAINS");
    return [200];
  });

  // get customer domains
  mock.onGet(CUSTOMER_DOMAINS).reply(async () => {
    let domains = await getStorage("CUSTOMER_DOMAINS");
    return [200, { domains }];
  });

  // add customer domains
  mock.onPost(CUSTOMER_DOMAIN).reply(async (config) => {
    const domianData = JSON.parse(config.data);
    await addDomain(domianData);
    return [200, {}];
  });

  // verify domian
  const verifyDomainApi = new RegExp(`${CUSTOMER_DOMAIN}.+${VERIFY}`);
  mock.onPost(verifyDomainApi).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 2];
    await verifyDomain(id);
    return [200, {}];
  });

  // delete domain
  const deleteDomainApi = new RegExp(`${CUSTOMER_DOMAIN}.+`);
  mock.onDelete(deleteDomainApi).reply(async (config) => {
    const id = config.url.split("/customer-domain/")[1];
    await deleteDomian(id);
    return [200, {}];
  });

  /*

    Reports

  */

  // Report List

  mock.onGet(REPORTS_BASE_URL).reply(async () => {
    let reports = await getStorage("REPORTS");
    if (!reports) {
      reports = allReports();
    }
    await setStorage("REPORTS", reports);
    return [200, reports];
  });

  // Report Details

  mock.onPost(OS_PATCH_REPORT_URL).reply(async (config) => {
    const data = config.data;
    const params = JSON.parse(data);
    let report =
      params.ReportId === "USAGE_TREND_APPS"
        ? usageTrendDetails()
        : await reportDetails();
    return [200, report];
  });

  // Report Exports

  mock.onGet(REPORT_EXPORTS_URL).reply(async (config) => {
    let reportExports = await getStorage("REPORT_EXPORTS");
    if (!reportExports) {
      reportExports = getReportExports();
    }
    await setStorage("REPORT_EXPORTS", reportExports);

    return [200, reportExports];
  });

  // Export Report

  const orgReportExportUrl = new RegExp(`${REPORTS_BASE_V2_URL}.+`);
  const botReportExportUrl = new RegExp(`${BOTS_BASE_URL}.+${REPORTS_URL}.+`);

  mock.onGet(orgReportExportUrl).reply(() => {
    return [200, {}];
  });

  mock.onGet(botReportExportUrl).reply(() => {
    return [200, {}];
  });

  // Download report

  const downloadReportApi = new RegExp(`${REPORT_EXPORTS_URL}.+${FILE}.+`);
  mock.onGet(downloadReportApi).reply(async (config) => {
    const filters = JSON.parse(decodeURI(config.url).split("Filters=")[1]);
    if (filters && filters.FileName) {
      const isWAFRAssessmentReport = filters.FileName.includes(
        WAFR_ASSESSMENT_REPORT_NAME
      );
      const isWAFRFindingsReport = filters.FileName.includes(
        WAFR_FINDING_REPORT_NAME
      );

      if (isWAFRAssessmentReport) {
        return [
          200,
          {
            DownloadURL:
              "/demoReports/DAY2_Well_Architected_Review___Assessment_Report___HumanTech_Production_Workload.pdf",
          },
        ];
      }

      if (isWAFRFindingsReport) {
        return [
          200,
          {
            DownloadURL:
              "/demoReports/DAY2_Well_Architected_Review___Findings_Report___HumanTech_Production_Workload.csv",
          },
        ];
      }
    }
    return [200, { DownloadURL: "test" }];
  });

  setUpFBPServices(mock);

  /*

    Settings - AWS Accounts

  */

  // Create Account
  const accountStatusApi = new RegExp(`${CUSTOMER_ACCOUNT_STATUS}.+`);

  mock.onGet(accountStatusApi).reply(() => {
    return [200, accountStatusData()];
  });

  mock.onPost(CUSTOMER_ACCOUNT + ACCOUNTS_TEMPLATES).reply(async (config) => {
    const data = JSON.parse(config.data);
    await setStorage("new_account_departmentId", data.DepartmentId);
    return [200, accountResponseData()];
  });

  const customerAccountApi = new RegExp(`${CUSTOMER_ACCOUNT}(?!aws/).+`);

  const customerAccountHierarchyURL = new RegExp(
    `${CUSTOMER_ACCOUNT_ORGANIZATION}.+hierarchy`
  );

  mock.onGet(customerAccountHierarchyURL).reply((config) => {
    return [200, orgHierarchyMock];
  });

  mock.onPut(customerAccountApi).reply(async (config) => {
    const data = JSON.parse(config.data);
    let accounts = await getStorage("ACCOUNTS");
    accounts.push(await addAccountData(data));
    await removeItem("new_account_departmentId");
    await setStorage("ACCOUNTS", accounts);
    return [200, "Account successfully added"];
  });

  mock.onGet(customerAccountApi).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 1];
    const accounts = await getStorage("ACCOUNTS");
    const account = accounts.find((a) => a.CustomerAccountId === id);
    return [200, accountDetails(account)];
  });

  // Remove Account

  mock.onPost(ACCOUNT_REMOVE_URL).reply(async (config) => {
    const data = JSON.parse(config.data);
    let accounts = await getStorage("ACCOUNTS");
    accounts = accounts.filter((a) => a.AccountNumber !== data.AccountNumber);
    await setStorage("ACCOUNTS", accounts);
    for (const item of LOCALSTORAGE_KEYS_WITH_ACCOUNTS) {
      await removeItem(item);
    }
    return [200, accountResponseData()];
  });

  //Data-refresh
  const dataRefreshUrl = new RegExp(`${DATA_REFRESH_BASE_URL}`);
  mock.onPost(dataRefreshUrl).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 1];
    let jobs = await getStorage("JOBS");
    let newJobs = await addJob(id, jobs);
    await setStorage("JOBS", newJobs);
    return [200, { JobId: uuidv4() }];
  });

  //Blueprints

  mock.onDelete(/\/blueprints\/[0-9a-zA-Z-]+/g).reply(async (config) => {
    const words = config.url.split("/");
    const id = words[2];

    let blueprints = await getStorage("BLUEPRINTS");
    blueprints = blueprints.filter((bp) => bp.BlueprintId !== id);
    await setStorage("BLUEPRINTS", blueprints);

    return [
      200,
      {
        Message: "Blueprint deleted successfully",
      },
    ];
  });

  const unshareBlueprintUrl = new RegExp(
    `${BLUEPRINTS_BASE_URL}.+${UNSHARE_BLUEPRINT_CATALOG_URL}`
  );
  mock.onPost(unshareBlueprintUrl).reply(async (config) => {
    const blueprintId = config.url.split("/")[2];

    const data = JSON.parse(config.data);

    let listShares = await getStorage("LIST_BLUEPRINT_SHARES");
    if (!listShares) {
      listShares = listBlueprintShares;
    }
    let updatedShares = unshareBlueprint(blueprintId, data, listShares);

    await setStorage("LIST_BLUEPRINT_SHARES", updatedShares);

    return [200, listShares];
  });

  const shareBlueprintUrl = new RegExp(
    `${BLUEPRINTS_BASE_URL}.+${SHARE_BLUEPRINT_CATALOG_URL}`
  );
  mock.onPost(shareBlueprintUrl).reply(async (config) => {
    const blueprintId = config.url.split("/")[2];

    const data = JSON.parse(config.data);

    let listShares = await getStorage("LIST_BLUEPRINT_SHARES");
    if (!listShares) {
      listShares = listBlueprintShares;
    }
    let updatedShares = shareBlueprint(blueprintId, data, listShares);

    await setStorage("LIST_BLUEPRINT_SHARES", updatedShares);

    return [200, listShares];
  });

  const listBlueprintSharesUrl = new RegExp(
    `${BLUEPRINTS_BASE_URL}.+${LIST_BLUEPRINT_SHARES_URL}`
  );
  mock.onGet(listBlueprintSharesUrl).reply(async (config) => {
    let listShares = await getStorage("LIST_BLUEPRINT_SHARES");
    if (!listShares) {
      listShares = await listBlueprintShares;
    }
    await setStorage("LIST_BLUEPRINT_SHARES", listShares);

    return [200, listShares];
  });

  const ecsClusterUrl = new RegExp(
    `${BLUEPRINTS_BASE_URL}.+${BLUEPRINTS_TEMPLATE_URL}`
  );
  mock.onGet(ecsClusterUrl).reply((config) => {
    const blueprintId = config.url.split("/")[4];
    let template = ecsClusterTemplate();
    if (blueprintId === "08ba970e-c190-5bd5-8576-df5ac27bdf0b") {
      template = bringYourOwnAppTemplate();
    }
    return [200, template];
  });

  const bpParameterUrl = new RegExp(
    `${BLUEPRINTS_BASE_URL}.+${MANIFEST_PARAMETERS_URL}`
  );
  mock.onGet(bpParameterUrl).reply(() => {
    const blueprintId = config.url.split("/")[4];
    let parameterGroups = getParameterGroups();
    if (blueprintId === "08ba970e-c190-5bd5-8576-df5ac27bdf0b") {
      parameterGroups = getBringYourOwnAppParameterGroups();
    }
    return [200, parameterGroups];
  });

  const getBlueprintCost = new RegExp(
    `${BLUEPRINTS_BASE_URL}.+${BLUEPRINT_COST_URL}`
  );
  mock.onPut(getBlueprintCost).reply(() => {
    const cost = {
      CostEstimate: "19",
      CostEstimateId: "",
    };
    return [200, cost];
  });

  mock.onPost(getBlueprintCost).reply(() => {
    const cost = {
      CostEstimate: "47",
      CostEstimateId: "",
    };
    return [200, cost];
  });

  // launch configuration

  const launchConfigs = new RegExp(
    `${BLUEPRINTS_BASE_URL}.+${LAUNCH_CONFIGURATIONS_URL}`
  );

  mock.onGet(launchConfigs).reply(async () => {
    let configurations = await getStorage("LAUNCH_CONFIGURATIONS");
    if (!configurations) {
      configurations = await getLaunchConfigurations();
    }
    await setStorage("LAUNCH_CONFIGURATIONS", configurations);

    return [200, configurations];
  });

  const updateLaunchConfig = new RegExp(
    `${BLUEPRINTS_BASE_URL}.+${LAUNCH_CONFIGURATION_URL}.+`
  );
  mock.onPut(updateLaunchConfig).reply(async (config) => {
    const url = config.url.split("/");
    const configId = url[url.length - 1];
    const configData = JSON.parse(config.data);
    let configurations = await getStorage("LAUNCH_CONFIGURATIONS");
    const index = configurations.findIndex((ele) => ele.Id === configId);
    if (configData.IsDefault) {
      const defaultConfigIndex = configurations.findIndex(
        (ele) => ele.IsDefault
      );
      configurations[defaultConfigIndex] = {
        ...configurations[defaultConfigIndex],
        IsDefault: false,
      };
    }
    configurations[index] = { ...configurations[index], ...configData };
    await setStorage("LAUNCH_CONFIGURATIONS", configurations);
    return [200, {}];
  });

  mock.onDelete(updateLaunchConfig).reply(async (config) => {
    const url = config.url.split("/");
    const configId = url[url.length - 1];
    let configurations = await getStorage("LAUNCH_CONFIGURATIONS");
    const index = configurations.findIndex((ele) => ele.Id === configId);
    configurations.splice(index, 1);
    await setStorage("LAUNCH_CONFIGURATIONS", configurations);
    return [200, {}];
  });

  const launchConfig = new RegExp(
    `${BLUEPRINTS_BASE_URL}.+${LAUNCH_CONFIGURATION_URL}`
  );

  mock.onPost(launchConfig).reply(async (config) => {
    const configData = JSON.parse(config.data);
    await createLaunchConfiguration(configData);
    return [200, {}];
  });

  //get appended role text
  const customPolicyDetails = new RegExp(
    `${BLUEPRINTS_BASE_URL}${BLUEPRINT_CUSTOM_POLICY_DETAILS}`
  );
  mock.onGet(customPolicyDetails).reply((config) => {
    const template = appendedRoleText();
    return [200, template];
  });

  // Create BP ID
  mock.onPost(BLUEPRINTS_BASE_URL).reply((config) => {
    const configData = JSON.parse(config.data);
    let blueprintId = uuidv4();
    if (configData.metadata.type === "Terraform") {
      blueprintId = CREATE_TERRAFORM_BP_ID;
    }
    return [200, { BlueprintId: blueprintId }];
  });

  // Update BP
  const updateBpUrl = new RegExp(`${BLUEPRINTS_BASE_URL}.+`);
  mock.onPut(updateBpUrl).reply(() => {
    return [200, { Message: "Blueprint updated successfully" }];
  });

  // Create BP
  const createBpUrl = new RegExp(`${BLUEPRINTS_BASE_URL}.+${UPLOAD_MANIFEST}`);
  mock.onPost(createBpUrl).reply(async (config) => {
    const data = JSON.parse(config.data);
    let blueprints = await getStorage("BLUEPRINTS");
    if (!blueprints) {
      blueprints = [];
    }
    const blueprint = createBlueprint(data);
    blueprints.push(blueprint);
    await setStorage("BLUEPRINTS", blueprints);
    return [200, {}];
  });

  const launchBlueprint = new RegExp(
    `${BLUEPRINTS_BASE_URL}.+${BLUEPRINTS_LAUNCH_URL}`
  );
  mock.onPost(launchBlueprint).reply((config) => {
    return [
      200,
      {
        JobId: "1",
      },
    ];
  });

  const getMetricData = new RegExp(
    `${ORG_APPLICATION_BASE_URL}.+${MONITORING_STATISTICS_URL}.+`
  );
  mock.onGet(getMetricData).reply((config) => {
    let result = getMonitoringMetricData(config);
    return [200, result];
  });

  const getMetrics = new RegExp(
    `${ORG_APPLICATION_BASE_URL}.+${MONITORING_URL}`
  );

  mock.onGet(getMetrics).reply(async (config) => {
    let metricsData = await getStorage("APP_MONITORING");
    if (!metricsData) {
      const template = ecsClusterManifest();
      metricsData = template.ManifestTemplateContent.monitoring;
    }
    return [200, metricsData];
  });

  const updateMetricsApi = new RegExp(
    `${ORG_APPLICATION_BASE_URL}.+${MONITORING_URL}`
  );

  mock.onPost(updateMetricsApi).reply(async (config) => {
    let data = JSON.parse(config.data);
    let result = data && {
      metrics: [...data.Monitoring.metrics],
      order: [...data.Monitoring.order],
    };
    await setStorage("APP_MONITORING", result);
    return [200, result];
  });

  mock
    .onGet(
      "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/alphafold_sagemaker_notebook/AlphaFoldSagemakerPermission.json"
    )
    .reply(async (config) => {
      // for terraform
      return [200, BLUEPRINT_ROLE_PERMISSIONS];
    });

  const getallStacks = new RegExp(
    `${BLUEPRINTS_BASE_URL}.+${BLUEPRINTS_STACKS_URL}`
  );
  mock.onGet(getallStacks).reply(async (config) => {
    const blueprintId = config.url.split("/")[4];
    let stacksData = await getStacksData();

    if (config.url.includes(TERRAFORM_COMPLETED_BP_ID)) {
      stacksData = await getCompletedTerraformExecutionHistory();
      return [200, stacksData];
    }

    if (config.url.includes(TERRAFORM_DRAFT_BP_ID)) {
      stacksData = [];
      return [200, stacksData];
    }

    if (blueprintId === "08ba970e-c190-5bd5-8576-df5ac27bdf0b") {
      stacksData = await getStacksDataByoa();
    }
    return [200, stacksData];
  });

  const getAllStacks = new RegExp(`${BLUEPRINTS_HISTORY_URL}`);
  mock.onGet(getAllStacks).reply(async () => {
    return [200, await getStacksData("all")];
  });

  const getBlueprintIdUrl = new RegExp(`${BLUEPRINT_ID_URL}.+`);
  mock.onGet(getBlueprintIdUrl).reply((config) => {
    const words = config.url.split("/");
    let envId = words[3];

    if (envId === TERRAFORM_ENV_ID) {
      return [200, { BlueprintId: TERRAFORM_COMPLETED_BP_ID }];
    }

    return [200, blueprintId()];
  });

  const getBlueprintConfigUrl = new RegExp(`${BLUEPRINT_CONFIG_URL}.+`);
  mock.onGet(getBlueprintConfigUrl).reply((config) => {
    const envId = config.url.split("/").at(-1);
    const data =
      envId === TERRAFORM_ENV_ID ? terraformAppParameters() : appParameters();
    return [200, data];
  });

  // get tasks in blueprint details.
  const getBundledTasksUrl = new RegExp(
    `${BLUEPRINTS_BASE_URL}.+${ROUTINE_TASKS_URL}`
  );
  mock.onGet(getBundledTasksUrl).reply((config) => {
    const blueprintId = config.url.split("/")[4];
    let actions = getBundledActions();
    if (blueprintId === "08ba970e-c190-5bd5-8576-df5ac27bdf0b") {
      actions = getBundledActionsByoa();
    }
    // if (windowsLinuxBlueprintIDs.includes(blueprintId)) {
    //   actions = getEC2BlueprintActions();
    // }
    return [200, actions];
  });

  // enable/disable tasks in blueprint details.
  mock.onPut(getBundledTasksUrl).reply(async (config) => {
    const data = JSON.parse(config.data);
    let actions = await getStorage("BUNDLED_ACTIONS");
    if (!actions) {
      actions = getBundledActions();
    }
    actions = actions.map((task) =>
      task.actionId === data.ActionId
        ? { ...task, enabled: data.Enabled }
        : task
    );
    await setStorage("BUNDLED_ACTIONS", actions);
    return [200, actions];
  });

  // add tasks in blueprint details.
  mock.onPost(getBundledTasksUrl).reply(async (config) => {
    const data = JSON.parse(config.data);
    const newTask = {
      actionId: uuidv4(),
      name: data.Name,
      label: data.Name.toUpperCase().charAt(0) + data.Name.substring(1),
      enabled: true,
      description: data.Description,
      type: "CloudFormationUpdate",
      script: {
        Parameters: {},
      },
    };
    let actions = await getStorage("BUNDLED_ACTIONS");
    actions.push(newTask);
    await setStorage("BUNDLED_ACTIONS", actions);
    return [200, actions];
  });

  //delete bundle task
  mock.onDelete(getBundledTasksUrl).reply(async (config) => {
    const data = JSON.parse(config.data);
    let actions = await getStorage("BUNDLED_ACTIONS");
    actions = actions.filter((task) => task.actionId !== data.ActionId);
    await setStorage("BUNDLED_ACTIONS", actions);
    return [200, actions];
  });

  mock.onGet(/\/blueprints\/([^/]+)\/file\?Path=(.*)/g).reply((config) => {
    const bpId = config.url.split("/")[2];
    const regex = /Path=([^&]+)/;
    const match = regex.exec(config.url);
    const pathValue = decodeURIComponent(match[1]);

    const tfFileContent = {
      [TERRAFORM_COMPLETED_BP_ID]: TF_FILE_CONTEN_S3,
      [TERRAFORM_DRAFT_BP_ID]: TF_FILE_CONTEN_EC2,
    };

    if (bpId in tfFileContent) {
      const key = Object.keys(tfFileContent[bpId]).find((path) => {
        return pathValue.includes(path.split("/")[1]);
      });
      const data = tfFileContent[bpId][key];
      return [
        200,
        {
          data: tfFileContent[bpId][key],
          Name: key,
          FileContent: data.content,
        },
      ];
    }
  });

  const terraformInfraSetupUrl = new RegExp(
    `${BLUEPRINTS_BASE_URL}${TERRAFORM_INFRA_SETUP_URL}+`
  );
  let isConfigureInfraDone = false;

  mock.onGet(terraformInfraSetupUrl).reply(async (config) => {
    return [200, isConfigureInfraDone];
  });
  const terraformConfigureInfraUrl = new RegExp(
    `${BLUEPRINTS_BASE_URL}${TERRAFORM_INFRA_CONFIG_URL}`
  );
  mock.onPost(terraformConfigureInfraUrl).reply(async (config) => {
    isConfigureInfraDone = true;
    return [200];
  });

  const ecsManifestUrl = new RegExp(`${BLUEPRINTS_BASE_URL}.+`);
  mock.onGet(ecsManifestUrl).reply((config) => {
    const blueprintId = config.url.split("/")[2];
    let manifest;

    if (blueprintId === TERRAFORM_DRAFT_BP_ID) {
      manifest = terraformManifestDraft;
      return [200, manifest];
    }

    if (blueprintId === TERRAFORM_COMPLETED_BP_ID) {
      manifest = terraformManifestCompleted;
      return [200, manifest];
    }

    if (blueprintId === CREATE_TERRAFORM_BP_ID) {
      manifest = terraformCreateManifest;
      return [200, manifest];
    }

    if (blueprintId === "08ba970e-c190-5bd5-8576-df5ac27bdf0b") {
      manifest = bringYourOwnAppManifest();
      return [200, manifest];
    }

    manifest = ecsClusterManifest();
    return [200, manifest];
  });

  //Users & Roles
  mock.onGet(ROLES_BASE_URL).reply(async () => {
    let allRoles = await getStorage("ADMIN_ROLES");
    if (!allRoles) {
      allRoles = roles();
    }
    await setStorage("ADMIN_ROLES", allRoles);
    return [200, allRoles];
  });

  const roleDetailsUrl = new RegExp(`${ROLE_BASE_URL}.+`);

  mock.onGet(roleDetailsUrl).reply(async (config) => {
    const roleId = config.url.split("role/")[1];
    let allRoles = await getStorage("ADMIN_ROLES");
    if (!allRoles) {
      allRoles = roles();
    }
    const details = allRoles.find((r) => r.ID === roleId);
    return [200, details];
  });

  mock.onPost(roleDetailsUrl).reply(async (config) => {
    let allUsers = await getStorage("ADMIN_USERS");
    let userIds = JSON.parse(config.data);
    const allSelectedUsers = [];
    userIds.forEach((id) => {
      let item = allUsers.find((user) => id === user.ID);
      allSelectedUsers.push(item);
    });
    let allRoles = await getStorage("ADMIN_ROLES");
    if (!allRoles) {
      allRoles = roles();
    }
    const roleId = config.url.split("/")[4];
    const role = allRoles.find((r) => r.ID === roleId);
    role.Users = role.Users.concat(allSelectedUsers);
    role.UsersCount = role.Users.length;
    await setStorage("ADMIN_ROLES", allRoles);
    return [200, {}];
  });

  mock.onGet(USERS_BASE_URL).reply(async () => {
    let allUsers = await getStorage("ADMIN_USERS");
    if (!allUsers) {
      allUsers = users();
    }
    await setStorage("ADMIN_USERS", allUsers);
    return [200, allUsers];
  });

  mock.onGet(USER_BASE_URL).reply(() => {
    return [200, userDetails];
  });

  mock.onPost(USER_BASE_URL).reply(async (config) => {
    const data = JSON.parse(config.data);
    let allUsers = (await getStorage("ADMIN_USERS")) || [];
    const user = createUser(data, allUsers);
    allUsers.push(user);
    await setStorage("ADMIN_USERS", allUsers);
    return [200, {}];
  });

  const addfreetrail = new RegExp(`${"subscription/plan"}.+`);

  mock.onPost(addfreetrail).reply(() => {
    return [
      200,
      {
        Message: "success",
      },
    ];
  });

  const notificationsUrl = new RegExp(`${NOTIFICATIONS_BASE_URL}`);

  mock.onGet(notificationsUrl).reply(async () => {
    let notificationList = await getStorage("NOTIFICATIONS_LIST");
    if (!notificationList) {
      notificationList = getNotificationList();
    }
    await setStorage("NOTIFICATIONS_LIST", notificationList);
    return [200, notificationList];
  });

  mock.onPut(notificationsUrl).reply(async () => {
    let notificationList = await getStorage("NOTIFICATIONS_LIST");
    notificationList.openCount = 0;
    await setStorage("NOTIFICATIONS_LIST", notificationList);
    return [200, { message: "Updated" }];
  });

  mock.onPost(USERS_BASE_URL).reply(async (config) => {
    const data = JSON.parse(config.data);
    let allUsers = await getStorage("ADMIN_USERS");
    const user = createUser(data, allUsers);
    allUsers.push(user);
    await setStorage("ADMIN_USERS", allUsers);
    return [200, {}];
  });

  //SESSIONS MANAGER
  const sessionsListUrl = new RegExp(`${EC2_INSTANCE_SESSIONS_LIST_URL}+`);

  mock.onGet(sessionsListUrl).reply((config) => {
    return [200, remoteSessionsList];
  });

  const startInstanceUrl = new RegExp(`${EC2_INSTANCE_SESSION_START_URL}+`);

  mock.onPost(startInstanceUrl).reply((config) => {
    return [200, startSessionData];
  });

  const terminateInstanceUrl = new RegExp(
    `${EC2_INSTANCE_SESSION_TERMINATE_URL}+`
  );

  mock.onPost(terminateInstanceUrl).reply((config) => {
    return [200, terminateSessionData];
  });

  const createSnapshot = new RegExp(`${EC2_SNAPSHOT_INSTANCE_URL}+`);

  mock.onPost(createSnapshot).reply(() => {
    return [200, {}];
  });

  mock.onGet(APP_ALERTS_URL).reply(async () => {
    let alerts = await getStorage("APP_ALERTS");
    if (!alerts) {
      alerts = getAppAlerts();
    }
    await setStorage("APP_ALERTS", alerts);
    return [200, alerts];
  });

  // Change Configuration
  const changeConfiguration = new RegExp(
    `${ORG_APPLICATION_BASE_URL}.+${CHANGE_CONFIGURATION}`
  );
  mock.onPost(changeConfiguration).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 2];
    let jobs = await getStorage("JOBS");
    var data = {
      name: "Update Application Configuration",
      status: "RUNNING",
    };
    let job = await createJob(data);
    job.ActionData.ApplicationId = id;
    jobs.push(job);
    await setStorage("JOBS", jobs);
    return [200, { JobId: uuidv4() }];
  });

  //IFTTT
  const getAppTasksUrl = new RegExp(
    `${ORG_APPLICATION_BASE_URL}.+${TASK_BASE_URL}.+`
  );
  mock.onGet(getAppTasksUrl).reply(() => {
    const data = getAppTasks();
    return [200, data];
  });

  const getEventConditionsDataUrl = new RegExp(`${EVENT_METADATA}/.+`);
  mock.onGet(getEventConditionsDataUrl).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 1];
    const data = getEventConditionsData(id);
    return [200, data];
  });

  const getEventsDataUrl = new RegExp(`${EVENT_METADATA}`);
  mock.onGet(getEventsDataUrl).reply(() => {
    const event_metadata = getEventsMetadata();
    return [200, event_metadata];
  });

  const executionHistoryUrl = new RegExp(
    `${APP_RULES}${APP_EXECUTION_HISTORY}`
  );
  mock.onGet(executionHistoryUrl).reply(async () => {
    let allRules = await getStorage("APP_RULES");
    const data = isArrayWithLength(allRules)
      ? allRules.map((rule) => ({
          RuleId: rule.RuleId,
          RuleName: rule.RuleName,
          Trigger: `${rule.RuleType}-${rule.MetricType}`,
          ExecutedAt: rule.UpdatedAt,
          Status: "Completed (1/1)",
        }))
      : [];
    return [200, data];
  });

  const getRulesUrl = new RegExp(`${APP_RULES}`);
  mock.onGet(getRulesUrl).reply(async () => {
    let rules = await getStorage("APP_RULES");
    if (!rules) {
      rules = getRules();
      await setStorage("APP_RULES", rules);
    }
    return [200, rules];
  });

  const saveRuleUrl = new RegExp(`${APP_RULES}`);
  mock.onPost(saveRuleUrl).reply(async (config) => {
    const data = JSON.parse(config.data);
    let allRules = (await getStorage("APP_RULES")) || [];
    const rule = createRule(data, allRules);
    allRules.push(rule);
    await setStorage("APP_RULES", allRules);
    return [200, rule.RuleId];
  });

  const updateRuleUrl = new RegExp(`${APP_RULES}/.+`);
  mock.onPut(updateRuleUrl).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 1];
    const data = JSON.parse(config.data);
    let allRules = await getStorage("APP_RULES");
    const index = allRules.findIndex((rule) => rule.RuleId === id);
    allRules[index] = { ...allRules[index], ...data };
    await setStorage("APP_RULES", allRules);
    return [200, id];
  });

  const deleteRuleUrl = new RegExp(`${APP_RULES}/.+`);
  mock.onDelete(deleteRuleUrl).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 1];
    let allRules = await getStorage("APP_RULES");
    const index = allRules.findIndex((rule) => rule.RuleId === id);
    allRules.splice(index, 1);
    await setStorage("APP_RULES", allRules);
    return [200, id];
  });

  // Bots
  const botInsights = new RegExp(`${BOTS_BASE_URL}.+${INSIGHTS}`);
  mock.onGet(botInsights).reply(async (config) => {
    const fullParams = JSON.parse(
      decodeURI(config.url).split("=")[1].split("&")[0]
    );
    const botId = config.url.split("?")[0].split("/").slice(-2)[0];
    let newInsightsData = COMPLIANCE_INSIGHTS;
    const botKey = `insights-${botId}`;
    let insights = await getStorage(botKey);

    if (!insights) {
      insights = await getAllBotInsights(botId);
      await setStorage(botKey, insights);
    }

    if (fullParams.Accounts && fullParams.Accounts.length > 0) {
      insights = insights.filter((insight) =>
        fullParams.Accounts.includes(insight.AccountNumber)
      );
    }
    if (fullParams.Depts && fullParams.Depts.length > 0) {
      insights = insights.filter((insight) =>
        fullParams.Depts.includes(insight.DepartmentId)
      );
    }
    if (fullParams.Regions && fullParams.Regions.length > 0) {
      insights = insights.filter((insight) =>
        fullParams.Regions.includes(insight.RegionCode)
      );
    }
    if (fullParams.ResourceTypes && fullParams.ResourceTypes.length > 0) {
      insights = insights.filter((insight) =>
        fullParams.ResourceTypes.includes(insight.ResourceType)
      );
    }
    if (fullParams.Apps && fullParams.Apps.length > 0) {
      insights = insights.filter((insight) =>
        fullParams.Apps.includes(insight.ApplicationId)
      );
    }
    if (botKey === `insights-${COMPLIANCE_BOT_ID}`) {
      let newInsights = [];
      newInsights = newInsightsData.concat(insights);

      return [200, { Items: newInsights }];
    } else {
      return [200, { Items: insights }];
    }
  });

  const getRemediations = new RegExp(`${BOTS_BASE_URL}.+${REMEDIATE}`);

  mock.onGet(getRemediations).reply(() => {
    const remediations = getAllRemediations();
    return [200, remediations];
  });

  const botIndustryStandards = new RegExp(
    `${BOTS_BASE_URL}.+${BOT_INDUSTRY_SUMMARY}`
  );
  mock.onGet(botIndustryStandards).reply(async () => {
    let botIndustryStandard = await getStorage("BOT_INDUSTRY_STANDARD");

    if (!botIndustryStandard) {
      botIndustryStandard = await getBotIndustryStandards();
      await setStorage("BOT_INDUSTRY_STANDARD", botIndustryStandard);
    }

    return [200, botIndustryStandard];
  });

  const botManifest = new RegExp(`${BOTS_BASE_URL}.+/${MANIFEST}`);

  mock.onGet(botManifest).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 2];
    let botManifest = await getStorage("BOT_MANIFEST");
    if (!botManifest) {
      botManifest = await getBotManifest(id);
    }
    return [200, botManifest];
  });

  const launchBotConfig = new RegExp(`${BOTS_BASE_URL}.+/${CONFIGURE}`);

  mock.onPost(launchBotConfig).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 2];
    const botData = JSON.parse(config.data);
    configureBot(id, botData);
    return [200, {}];
  });

  mock.onPut(launchBotConfig).reply((config) => {
    const url = config.url.split("/");
    const id = url[url.length - 2];
    const botData = JSON.parse(config.data);
    configureBot(id, botData);
    return [200, {}];
  });

  const preRequisitesApi = new RegExp(
    `${BOTS_BASE_URL}.+${PREREQUISITES_CHECK}`
  );

  mock.onGet(preRequisitesApi).reply((config) => {
    const region = config.url.split("RegionCode=")[1];
    const botId = config.url.split("?")[0].split("/").slice(-2)[0];
    const preRequisites = getPreRequisites(botId, region);
    return [200, preRequisites];
  });
  const suppressInsightURL = new RegExp(`${BOTS_BASE_URL}.+${SUPPRESS}`);

  mock.onPost(suppressInsightURL).reply(() => {
    return [200, {}];
  });

  const remediateInsightURL = new RegExp(`${BOTS_BASE_URL}.+${REMEDIATE}`);

  mock.onPost(remediateInsightURL).reply(async (config) => {
    const splitUrl = config.url.split("?")[0].split("/");
    const insightId = splitUrl.slice(-2)[0];
    const botId = splitUrl.slice(-4)[0];
    const botKey = `insights-${botId}`;
    let insights = await getStorage(botKey);
    var insightIndex = insights.findIndex((i) => i.InsightId === insightId);
    if (insightIndex >= 0) {
      const botType = getBotType(botId);
      if (botType) {
        insights[insightIndex][
          botType === BOT_TYPE_COMPLIANCE ? "ComplianceType" : "InsightStatus"
        ] = botType === BOT_TYPE_COMPLIANCE ? "COMPLIANT" : "PASSED";
      }
      insights[insightIndex].TaskDetails = {
        Executed: true,
        TaskName:
          botType && botType === BOT_TYPE_COMPLIANCE
            ? "Enable S3 Bucket Encryption"
            : "Remove all Inbound and Outbound Rules",
      };
      await setStorage(botKey, insights);
    }
    return [200, {}];
  });

  const getOpsSummaryUrl = new RegExp(`${BOTS_BASE_URL}.+${OPS_SUMMARY}`);
  mock.onGet(getOpsSummaryUrl).reply((config) => {
    let filters = decodeURI(config.url).split("=");
    let appId;
    let deptId;
    if (isArrayWithLength(filters) && filters.length >= 2) {
      filters = JSON.parse(filters[1]);
      appId = filters.Apps;
      deptId = filters.Depts;
    }
    const data = getBotOpsSummary(deptId, appId);
    return [200, data];
  });

  const insightsJobsURL = new RegExp(`${BOTS_BASE_URL}.+${JOBS_BASE_URL}`);
  mock.onGet(insightsJobsURL).reply(async () => {
    let insightsJobs = await getStorage("JOBS");
    if (!insightsJobs) {
      insightsJobs = await allJobs();
    }
    await setStorage("JOBS", insightsJobs);
    return [200, insightsJobs];
  });

  const botSummaryURL = new RegExp(`${BOTS_BASE_URL}.+${BOT_SUMMARY}`);
  mock.onGet(botSummaryURL).reply(async (config) => {
    const botId = config.url.split("?")[0].split("/").slice(-2)[0];
    const botSummaryKey = `bot-summary-${botId}`;
    let summary = await getStorage(botSummaryKey);
    if (!summary) {
      const botType = getBotType(botId);
      const botInsightsKey = `insights-${botId}`;
      let botInsights = await getStorage(botInsightsKey);
      if (!botInsights) {
        botInsights = await getAllBotInsights(botId);
        await setStorage(botInsightsKey, botInsights);
      }
      summary = await getBotSummary(botType, botInsights);
    }
    return [200, summary];
  });

  const botConfigUrl = new RegExp(`${BOTS_BASE_URL}/.+/${CONFIG}`);
  mock.onGet(botConfigUrl).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 2];
    const botConfig = await getBotConfig(id);
    return [200, botConfig];
  });

  const botOffBoardingUrl = new RegExp(`${BOTS_BASE_URL}.+/${OFFBOARDING}`);
  mock.onDelete(botOffBoardingUrl).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 2];
    const data = JSON.parse(config.data);
    await offBoardBot(id, data.Targets);
    return [200, {}];
  });

  const botBaseUrl = new RegExp(`${BOTS_BASE_URL}.+`);

  mock.onGet(botBaseUrl).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 1];
    let botDetails = await getStorage("BOT_DETAILS");
    if (!botDetails) {
      botDetails = getBotDetails(id);
    }
    return [200, botDetails];
  });

  mock.onDelete(botBaseUrl).reply(() => {
    return [200, {}];
  });

  mock.onGet(BOTS_BASE_URL).reply(async () => {
    let bots = await getStorage("LIST_BOTS");
    if (!bots) {
      bots = await getAllBots();
    }
    await setStorage("LIST_BOTS", bots);
    return [200, bots];
  });

  // const tagPolicies = new RegExp(`${TAG_POLICIES}.+`);
  // mock.onGet(tagPolicies).reply(async () => {
  //   let tagPolicies = await getStorage("TAG_POLICIES");
  //   if (!tagPolicies) {
  //     tagPolicies = getTagPolicies();
  //   }
  //   await setStorage("TAG_POLICIES", tagPolicies);
  //   return [200, tagPolicies];
  // });

  // mock.onPost(TAG_POLICIES).reply(async () => {
  //   let tagPolicies = await getStorage("TAG_POLICIES");
  //   if (!tagPolicies) {
  //     tagPolicies = getTagPolicies();
  //   }
  //   await setStorage("TAG_POLICIES", tagPolicies);
  //   return [200, tagPolicies];
  // });

  // // Create Desired State Policy
  // mock.onPost(TAG_POLICIES).reply(async (config) => {
  //   const newData = JSON.parse(config.data);
  //   let newPolicy = saveTagPolicyData(newData);
  //   let dsPolicies = await getStorage("TAG_POLICIES");
  //   dsPolicies.push(newPolicy);
  //   await setStorage("TAG_POLICIES", dsPolicies);
  //   return [200, "Tag policy has been created successfully"];
  // });

  //delete deisred state policy
  // mock.onDelete(tagPolicies).reply(async (config) => {
  //   const url = config.url.split("/");
  //   const id = url[url.length - 1];
  //   const remainingTagPolicies = [];
  //   const tagPolicies = await getStorage("TAG_POLICIES");
  //   tagPolicies.map((policy) => {
  //     return id !== policy.ID && remainingTagPolicies.push(policy);
  //   });
  //   await setStorage("TAG_POLICIES", remainingTagPolicies);
  //   return [200, "Successfully Deleted Tag policy"];
  // });
  // File Storage

  const deleteFileObjects = new RegExp(
    `${ORG_APPLICATION_BASE_URL}.+${STORAGE_OBJECTS}${FILE}`
  );

  mock.onDelete(deleteFileObjects).reply(() => {
    return [200];
  });

  const deleteFolderObjects = new RegExp(
    `${ORG_APPLICATION_BASE_URL}.+${STORAGE_OBJECTS}${FOLDER}`
  );

  mock.onDelete(deleteFolderObjects).reply(() => {
    return [200];
  });

  const getFileObjects = new RegExp(
    `${ORG_APPLICATION_BASE_URL}.+${STORAGE_OBJECTS}`
  );

  mock.onGet(getFileObjects).reply(async (config) => {
    let fileObjects = await getStorage("APP_FILE_OBJECTS");
    let path = config.url.split("Path=")[1].split("&")[0];
    if (path === "/") {
      path = null;
    }

    if (!fileObjects || path) {
      fileObjects = allFileObjects(path);
      if (!path) {
        await setStorage("APP_FILE_OBJECTS", fileObjects);
      }
    }
    return [200, fileObjects];
  });

  const deleteProjectFileObjects = new RegExp(
    `${ORG_DEPARTMENT_BASE_URL}.+${STORAGE_OBJECTS}${FILE}`
  );

  mock.onDelete(deleteProjectFileObjects).reply(() => {
    return [200];
  });

  const deleteProjectFolderObjects = new RegExp(
    `${ORG_DEPARTMENT_BASE_URL}.+${STORAGE_OBJECTS}${FOLDER}`
  );

  mock.onDelete(deleteProjectFolderObjects).reply(() => {
    return [200];
  });

  const getProjectFileObjects = new RegExp(
    `${ORG_DEPARTMENT_BASE_URL}.+${STORAGE_OBJECTS}`
  );

  mock.onGet(getProjectFileObjects).reply(async (config) => {
    let fileObjects = await getStorage("PROJECT_FILE_OBJECTS");
    let path = config.url.split("Path=")[1].split("&")[0];
    if (path === "/") {
      path = null;
    }

    if (!fileObjects || path) {
      fileObjects = allProjectFileObjects(path);
      if (!path) {
        await setStorage("PROJECT_FILE_OBJECTS", fileObjects);
      }
    }
    return [200, fileObjects];
  });

  // -------------------------------------------------------------------

  const productCatalog = new RegExp(`${SUBSCRIPTION}${PRODUCT_CATALOG}`);

  mock.onGet(productCatalog).reply(() => {
    let productCatalog = JSON.parse(localStorage.getItem("PRODUCT_CATALOG"));
    if (!productCatalog) {
      productCatalog = subscriptionProductCatalog();
    }
    localStorage.setItem("PRODUCT_CATALOG", JSON.stringify(productCatalog));
    return [200, productCatalog];
  });

  const enterprise = new RegExp(`${SUBSCRIPTION}${ENTERPRISE_REQUEST}`);

  mock.onPost(enterprise).reply(() => {
    return [200];
  });

  const subscription = new RegExp(`${SUBSCRIPTION}.+`);

  mock.onPut(subscription).reply(() => {
    return [
      200,
      {
        SubscriptionId: "",
        SessionId:
          "cs_test_c1JQwzxO9unyRl06X1oIZBDP7i4NCDvk7NdONkDKZcNdFfMXDuRJolqbhI",
      },
    ];
  });

  mock.onGet(SUBSCRIPTION).reply(() => {
    let subscribedPlan = JSON.parse(localStorage.getItem("SUBSCRIBED_PLANS"));
    if (!subscribedPlan) {
      subscribedPlan = subscribedPlans();
    }
    localStorage.setItem("SUBSCRIBED_PLANS", JSON.stringify(subscribedPlan));
    return [200, subscribedPlan];
  });

  const subscriptionPlan = new RegExp(`${SUBSCRIPTION}.+${PLANS}`);

  mock.onPut(subscriptionPlan).reply(() => {
    return [200];
  });

  mock.onDelete(subscriptionPlan).reply(() => {
    return [200];
  });

  const getResourceInsightTypesURL = new RegExp(
    `${ORG_BASE_URL}${RESOURCE_INSIGHTS_URL}/${RESOURCE_TYPES}.+`
  );

  mock.onGet(getResourceInsightTypesURL).reply(async () => {
    return [200, getResourceInsightTypes()];
  });

  const getResourceInsightsURL = new RegExp(
    `${ORG_BASE_URL}${RESOURCE_INSIGHTS_URL}.+`
  );

  mock.onGet(getResourceInsightsURL).reply(async (config) => {
    const queryParams = new URLSearchParams(
      decodeURI(config.url).split("?")[1]
    );

    const filtersJson = queryParams.get("Filters");
    const filterParams = filtersJson
      ? JSON.parse(decodeURIComponent(filtersJson))
      : {};
    const resourceType =
      Array.isArray(filterParams.ResourceType) && filterParams.ResourceType[0];

    const offset = queryParams.has("Offset")
      ? Number(queryParams.get("Offset"))
      : 0;
    const limit = queryParams.has("Limit")
      ? Number(queryParams.get("Limit"))
      : 20;

    let resourceInsights = await getResourceInsights(
      resourceType,
      limit,
      offset
    );
    return [200, resourceInsights];
  });

  const getResourceInsightsOnDemandURL = new RegExp(
    `${ORG_BASE_URL}${RESOURCE_INSIGHTS_URL}`
  );

  mock.onPost(getResourceInsightsOnDemandURL).reply(() => {
    return [200, {}];
  });

  const getResourceInsightSummaryURL = new RegExp(
    `${ORG_BASE_URL}${RESOURCE_INSIGHT_SUMMARY_URL}.+`
  );

  mock.onGet(getResourceInsightSummaryURL).reply((config) => {
    const filters = JSON.parse(decodeURI(config.url).split("Filters=")[1]);
    let resourceInsights = getResourceInsightSummary(filters);
    return [200, resourceInsights];
  });

  const customerPreferenceUrl = new RegExp(`${CUSTOMER_PREFERENCE}`);

  mock.onPost(customerPreferenceUrl).reply((config) => {
    let req = JSON.parse(config.data);

    let data = {
      Preference: customerPreferencesBasic,
    };

    if (req.Preference === FEATURE_PLANS.CONTINUOUS_VISIBILITY) {
      data.Preference = customerPreferencesBasic;
    }

    if (req.Preference === FEATURE_PLANS.AUTOMATED_CLOUD_OPS) {
      data.Preference = customerPreferencesAdvance;
    }

    return [200, data];
  });

  mock.onGet(customerPreferenceUrl).reply(() => {
    let data = {
      Features: [
        "Visibility",
        "WellArchitectedReview",
        "WellArchitectedReviewRemediation",
        "CloudGorvernance",
        "ServerManagement",
        "ApplicationManagement",
      ],
    };

    //continuousVisibilityPlan.features

    return [200, data];
  });

  const getCfnUrl = new RegExp(`${CFN}`);
  mock.onGet(getCfnUrl).reply(() => {
    const data = {
      UpgradeURL:
        "https://mcdev1customeronboarding.s3.amazonaws.com/123456/upgrade_template.yaml",
      RegionCode: "us-east-1",
    };
    return [200, data];
  });

  const inventorySummaryApi = new RegExp(`${ORG_INVENTORY_SUMMARY}.+`);
  mock.onGet(inventorySummaryApi).reply(async (config) => {
    const completeQueryParams = decodeURI(config.url).split("Filters=");

    const filtersParams = completeQueryParams[1].split("&")[0];

    const summaryType = completeQueryParams[1].split("SummaryType=")[1];

    const fullParams = JSON.parse(filtersParams);
    const resourceType =
      typeof fullParams.ResourceType === "string"
        ? [fullParams.ResourceType]
        : fullParams.ResourceType;
    let resourceList = resourceType;
    let regionList = fullParams.Regions;
    let accountList = fullParams.Accounts;
    let response = await organizationSummary(
      accountList,
      regionList,
      resourceList
    );
    let inventory = [];
    if (summaryType === ALL_RESOURCES_SUMMARY_FILTERS.BY_ACCOUNT) {
      inventory = await inventorySummaryByAccount(response);
    }

    if (summaryType === ALL_RESOURCES_SUMMARY_FILTERS.BY_REGION) {
      inventory = await inventorySummaryByRegion(response);
    }

    if (summaryType === ALL_RESOURCES_SUMMARY_FILTERS.BY_RESOURCE_TYPE) {
      inventory = await inventorySummaryByResource(response);
    }

    return [200, inventory];
  });

  const governanceSummaryApi = new RegExp(`${ORG_GOVERNANCE_SUMMARY}`);
  mock.onGet(governanceSummaryApi).reply(async (config) => {
    const completeQueryParams = decodeURI(config.url).split("Filters=");
    const cloudProvider = completeQueryParams[1].split("CloudProvider=")[1];

    let orgSummary = await organizationSummary();
    let instanceCount = 3005;
    if (
      orgSummary &&
      orgSummary.ResourceSummary &&
      orgSummary.ResourceSummary.length > 0
    ) {
      instanceCount = orgSummary.ResourceSummary.filter(
        (ele) => ele.ResourceType === "Instance"
      )[0].ResourceCount;
    }
    let instances = await getStorage("INSTANCES");
    if (!instances) {
      instances = await allInstances(instanceCount, [], []);
    }

    let governance = {};

    if (cloudProvider === CLOUDPROVIDERS.AWS) {
      governance = await governanceSummary(instances);
    } else if (cloudProvider === CLOUDPROVIDERS.AZURE) {
      governance = await azureGovernanceSummary();
    }

    return [200, governance];
  });

  const getCostOptimizationSummaryUrl = new RegExp(
    `${ORG_COST_OPTIMIZATION_SUMMARY}`
  );

  mock.onGet(getCostOptimizationSummaryUrl).reply((config) => {
    const fullParams = JSON.parse(decodeURI(config.url).split("=")[1]);
    const depts = fullParams.Depts;
    const costOptimizationSummary = getCostOptimizationData(
      isArrayWithLength(depts) && depts[0]
    );
    return [200, costOptimizationSummary];
  });

  // const editDepartmentUrl = new RegExp(
  //   `${ORGANIZATION_BASE_URL}.+${DEPARTMENT_BASE_URL}.+`
  // );

  const deleteDepartmentUrl = new RegExp(
    `${ORGANIZATION_BASE_URL}.+${DEPARTMENT_BASE_URL}.+`
  );

  mock.onDelete(deleteDepartmentUrl).reply(async (config) => {
    const url = config.url.split("/");
    const id = url[url.length - 1];
    let departments = await getStorage(ACTIVE_PROJECTS);
    let organizations = await getStorage("ORGANIZATIONS");

    let projectIndex = departments.findIndex((project) => project.ID === id);

    if (
      isArrayWithLength(organizations) &&
      isArrayWithLength(organizations[0].Departments)
    ) {
      let projectIndex = organizations[0].Departments.findIndex(
        (project) => project.ID === id
      );
      if (projectIndex !== -1) {
        organizations[0].Departments.splice(projectIndex, 1);
        await setStorage("ORGANIZATIONS", organizations);
      }
    }

    if (projectIndex !== -1) {
      departments.splice(projectIndex, 1);
      await setStorage(ACTIVE_PROJECTS, departments);
    }

    return [200];
  });

  // mock.onPut(editDepartmentUrl).reply(() => {
  //   return [200, { ID: "test" }];
  // });

  const editOrganization = new RegExp(`${ORGANIZATION_BASE_URL}.+`);

  mock.onPut(editOrganization).reply(() => {
    return [200, { ID: "test" }];
  });

  const postFeedback = new RegExp(`${SUPPORT_TICKET_URL}`);

  mock.onPost(postFeedback).reply(() => {
    return [200, {}];
  });

  // File Storage

  const uploadFileFromInstanceUrl = new RegExp(
    `${ORG_APPLICATION_BASE_URL}.+${STORAGE}${EC2_FILE}${UPLOAD}`
  );

  mock.onPost(uploadFileFromInstanceUrl).reply(async () => {
    return [200, {}];
  });

  const downloadToAnInstance = new RegExp(
    `${ORG_APPLICATION_BASE_URL}.+${STORAGE}${EC2_FILE}.+`
  );

  mock.onGet(downloadToAnInstance).reply(async () => {
    return [200, {}];
  });


  // MFA

  mock.onPut(MFA_CONFIG_URL).reply(() => {
    return [200, {}];
  });

  const resetMFAURL = new RegExp(`auth/.+${RESET_MFA_CONFIG}`);

  mock.onPost(resetMFAURL).reply(() => {
    return [200, {}];
  });

  mock.onPost(INITIATE_MFA_SETUP_URL).reply(() => {
    return [
      200,
      {
        SecretKey: "CLISDJ",
        QRCode:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAAAAACMfPpKAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAfElEQVQYlU2QWwrEMAwDR0vuf+XZj8qJSyjIyNYjAkAMQNFhkBCKzoNiin70kxKBN41ENuf7+9AZWQOGRx/2m4TeKy2YO0GyDpwszW5EUCs/ur78NZtGvSa8azdPDGttsonot8LtDFNnrs4yLSbuJk0ajnV3vevhCxUj4Q+R11n764g4WgAAAABJRU5ErkJggg==",
      },
    ];
  });

  mock.onPost(REGISTER_MFA_DEVICE_URL).reply(() => {
    return [200, {}];
  });

  mock.onPost(VERIFY_MFA_URL).reply(() => {
    return [200, userDetails];
  });

  const portalUserURL = new RegExp(`${USERS_LIST_URL_V2}+`);

  mock.onGet(portalUserURL).reply(async (config) => {
    let filterType = decodeURI(decodeURI(config.url).split("?")[1]).split(
      "="
    )[0];
    let filters = decodeURI(config.url).split("=");
    let deptId;
    let roleId;

    let portalUsers = await getStorage(PORTAL_USERS);
    if (!portalUsers) {
      portalUsers = getPortalUsers();
    }
    await setStorage(PORTAL_USERS, portalUsers);

    if (filterType === "RoleId") {
      if (isArrayWithLength(filters) && filters.length >= 2) {
        roleId = filters[1];
      }
      if (roleId) {
        if (roleId === CUSTOMER_ROLE_FULL_ACCESS_ID) {
          portalUsers = portalUsers.filter(
            (user) => user.Roles === "Cloud Admin"
          );
        }
      }
    } else {
      if (isArrayWithLength(filters) && filters.length >= 2) {
        deptId = filters[1];
      }
      let portalUsers = await getStorage(PORTAL_USERS);
      if (!portalUsers) {
        portalUsers = getPortalUsers();
      }
      if (deptId) {
        let departments = await getStorage(ACTIVE_PROJECTS);
        if (!departments || Object.keys(departments).length === 0) {
          departments = getDepartmentsList();
        }
        await setStorage(ACTIVE_PROJECTS, departments);
        const dept =
          isArrayWithLength(departments) &&
          departments.find((dept) => dept.ID === deptId);
        portalUsers = portalUsers.slice(0, dept.Users);
      }
    }
    return [200, portalUsers];
  });

  setupMTServices(mock);

  // ACCOUNT VENDING
  // 1. control tower check
  const controlTowerCheckURL = new RegExp(
    `${AWS_ACCOUNT_BASE_URL}${CONTROL_TOWER_URL}${ManagementAccountId}${CONTROL_TOWER_ENABLED_URL}`
  );
  mock.onGet(controlTowerCheckURL).reply(() => {
    return [200, { Status: false }];
  });
  // 2. create new aws account
  const createAWSAccountURL = new RegExp(
    `${AWS_ACCOUNT_BASE_URL}${ManagementAccountId}${AWS_ACCOUNT_URL}`
  );
  mock.onPost(createAWSAccountURL).reply(async (config) => {
    const data = JSON.parse(config.data);
    const { AccountName, Email, OUId } = data;
    const newAcc = {
      Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/023653793110",
      Day2Onboarded: false,
      Email: Email,
      IS_MANAGEMENT_ACCOUNT: false,
      Id: "023653798987",
      JoinedMethod: "CREATED",
      JoinedTimestamp: new Date().toUTCString(),
      Name: AccountName,
      Status: "ACTIVE",
      Type: "ACCOUNT",
    };
    await updateOrgHierarchyData(newAcc, OUId);
    return [200, { RefId: "car-19ede4e11630430099cf098f8d4f62d8" }];
  });

  // 3. move account
  const moveAWSAccount = new RegExp(
    `${AWS_ACCOUNT_BASE_URL}${ManagementAccountId}${AWS_ACCOUNT_URL}`
  );
  mock.onPatch(moveAWSAccount).reply(async (config) => {
    const data = JSON.parse(config.data);
    await moveAccountToOU(data.AccountId, data.OUId);
    return [200, { Message: "SUCCESS" }];
  });
}
